import React, { forwardRef } from "react";
import _, { isEmpty } from "lodash";
import { ManualContractService } from "../../services/service-manualContract";
import { ServiceProjects } from "../../services/service-projects";
import { ServiceCheckExtension } from "../../services/service-check-file-extension";
import AppProjectSinglePurchase from "../app-project-single-purchase/app-project-single-purchase";
import "./app-project-purchase-list.css";
import appState from "../../state/AppStateContainer";
import { NotificationManager } from "react-notifications";
import SearchBarWithActions from '../../components/shared/SearchBarWithActions/SearchBarWithActions';
import FiltersDropdown from '../../components/shared/FiltersDropdown/FiltersDropdown';
import { ServiceUser } from "../../services/service-user";
import appEnum, { FileScope } from "../../util/appEnum";
import DataTable from "../../components/shared/DataTable/DataTable";
import { withRouter } from 'react-router-dom';
import Tabs from "../../components/shared/Tabs";
import BtButton from "../bt-button/bt-button";
import { ReactComponent as OpenedEyeIcon } from '../../assets/svg/openedEyeIcon.svg';
import { ReactComponent as CircleDollarIcon } from '../../assets/svg/circleDollarIcon.svg';
import { ReactComponent as CircleXIcon } from '../../assets/svg/circleXIcon.svg';
import { ReactComponent as CircleCheckIcon } from '../../assets/svg/circleCheckIcon.svg';
import { ReactComponent as CirclePendingIcon } from '../../assets/svg/circlePendingIcon.svg';
import { ReactComponent as FlyerTakenLightIcon } from '../../assets/svg/flyerTakenLightIcon.svg';
import { ReactComponent as InfoIcon } from '../../assets/svg/InfoIconLight.svg';
import { ContractIcon, TrashIcon } from '../../components/svgs';
import TooltipContainer from "../../components/shared/TooltipContainer/TooltipContainer";
import moment from "moment";
import { getDaysLeft, formatAmount, parseAmount, autosave } from "../../util";
import { resolveSupplierExpiry } from "../../util/supplierDeadline";
import File from "../../components/File/File";
import CustomizationMenu from "../../components/shared/CustomizationMenu/CustomizationMenu";
import ConversationModal from "../../components/shared/ConversationModal/ConversationModal";
import ConversationButton from "../../components/shared/ConversationModal/ConversationButton";
import NotificationCounter from "../../components/shared/NotificationCounter/NotificationCounter";
import TeamBuilder, { MAX_TEAM_SIZE } from "../../components/shared/TeamBuilder/TeamBuilder";
import TableField from "./TableField/TableField";
import TableDatePicker from "./TableDatePicker/TableDatePicker";
import Modal from "../../components/shared/Modal/Modal";
import styles from "./app-project-purchase-list.module.scss";
import LazyTooltipContainer from "../../components/shared/TooltipContainer/LazyTooltipContainer";
import AverageAdditionsPercentForCategoryTooltip from "./AverageAdditionsPercentForCategoryTooltip";
import { withTranslation, useTranslation, Trans } from "react-i18next";
import { useTableSorting } from "../../util/useTableSorting";
import hasValidFile from "../../util/validFile";
import * as Sentry from "@sentry/react";
import { canChangeStepTo, hasBindingContract } from "./purchaseStatus";
import {
  BULK_DEADLINE_MAX_RECIPIENTS,
  classifyBulkDeadlineError,
  didExtendAnything,
  selectionAfterBulkDeadline,
  summarizeBulkDeadlineFailures,
} from "../../util/bulkDeadlineResult";
import { chooseBulkDeadlineRefusal, summarizeExtendableSelection } from "../../util/bulkDeadlineSelection";
import { bucketSettledResults, needsNothingChangedNotice, selectionAfterBulkRun } from "../../util/bulkRunOutcome";
import DateExtensionModal from "../app-project-overview-item/DateExtensionModal";
import { PurchaseBids, PurchaseBidsTitle } from "./PurchaseBids/PurchaseBids";
import { bidsByPurchase, compareBidCounts } from "./PurchaseBids/bidsOfPurchase";
import { getProjectPriceRows } from "../../services/priceRowsService";
import InfoBox from "../../components/shared/InfoBox/InfoBox";
import { BidIntentStatus } from "../page-quotation/BidIntentControls/BidIntentControls";
import StyledCheckbox from "../../components/shared/StyledCheckbox/StyledCheckbox";
import FloatingActionBar, { FloatingActionBarButton, FloatingActionBarDivider } from "../../components/shared/FloatingActionBar/FloatingActionBar";
import PersonAddIcon from '@material-ui/icons/PersonAdd';
import ScheduleIcon from '@material-ui/icons/Schedule';
import SwapHorizIcon from '@material-ui/icons/SwapHoriz';
import DomainIcon from '@material-ui/icons/Domain';


const Badge = forwardRef(function Badge({ icon, value, color, bgColor, className, loading }, ref) {
  return (
    <div ref={ref} className={`${className} ${loading ? 'loading-badge' : ''}`} style={{ backgroundColor: bgColor || 'var(--gray-100)', display: 'flex', gap: '4px', height: '24px', width: 'fit-content', borderRadius: '4px', justifyContent: 'center', alignItems: 'center', padding: '4px 8px', minWidth: loading ? (icon ? '53px' : '24px') : '' }}>
      {!loading && icon}
      <span style={{ lineHeight: '16px', fontWeight: !icon ? '600' : '400', color: color ? color : 'var(--gray-700)' }}>{value}</span>
    </div>
  )
})

const ContractBadgeContent = ({ contracts, status }) => {
  const [t] = useTranslation('projects', { keyPrefix: 'purchaseList' });
  const formatDate = date => date && moment(date).locale('sv').format('D MMMM YYYY');
  const headline = t('contractBadge.headline', { context: status });
  const getStatus = (contract) => {
    if (status === 'PENDING') {
      return t(
        'contractBadge.status.pending',
        'skickat',
        { context: contract.createdAt ? 'createdAt' : null, timestamp: formatDate(contract.createdAt) }
      );
    } else if (status === 'DONE') {
      return t(
        'contractBadge.status.done',
        'manuellt signerat, {{timestamp}}',
        { context: contract.createdAt ? 'createdAt' : null, timestamp: formatDate(contract.signedAt ?? contract.createdAt) }
      );
    } else if (status === 'CANCELED') {
      return t('contractBadge.status.canceled', '', { context: contract.lastStatus })
    }
  };

  return (
    <div style={{ width: "max-content", maxWidth: 500 }}>
      <p style={{ fontWeight: 500, color: "var(--gray-900)", marginTop: 0 }}>{headline} ({contracts.length}):</p>
      <ul style={{ marginBottom: 0, listStylePosition: 'inside', padding: 0 }}>
        {contracts.map(contract => (
          <li key={contract.file}>
            <span style={{ fontWeight: 500, color: "var(--gray-900)" }}>{contract.fileName} </span>
            ({t('amount', '{{amount}} kr', { amount: formatAmount(contract.amount ?? '') || "–" })}), {getStatus(contract)}
          </li>
        ))}
      </ul>
    </div>
  );
}

// Ceiling on purchases one bulk supplier add may cover. The add sends no email, so this is about
// load rather than blast radius: the save issues one request per purchase, each doing its own
// supplier resolution. Matches BULK_DATE_MAX_AREAS in src/api/project.js, so the two bulk actions
// refuse at the same size rather than at two arbitrary ones.
const BULK_ADD_MAX_PURCHASES = 100;

const COLUMNS = [
  {
    id: 'Upphandling_1',
    i18nKey: 'columns.procurement',
    name: 'Upphandling',
    static: true,
    defaultOrder: 10,
  }, {
    id: 'Kontonummer_25',
    i18nKey: 'columns.accountNumber',
    name: 'Kontonummer',
    defaultOrder: 15,
  }, {
    id: 'Status_2',
    i18nKey: 'columns.status',
    name: 'Status',
    defaultOrder: 20,
  }, {
    id: 'Budget_3',
    i18nKey: 'columns.budget',
    name: 'Budget',
    defaultOrder: 30,
  }, {
    id: 'Kontraktssumma_4',
    i18nKey: 'columns.contractTotal',
    name: 'Kontraktssumma',
    isRenderedInStep: (step) => step >= 3,
    defaultOrder: 40,
  }, {
    id: 'Inköpsvinst_(SEK)_5',
    i18nKey: 'columns.profitSum',
    name: 'Inköpsvinst (SEK)',
    isRenderedInStep: (step) => step >= 3,
    defaultOrder: 50,
  }, {
    id: 'Inköpsvinst_(%)_6',
    i18nKey: 'columns.profitPercentage',
    name: 'Inköpsvinst (%)',
    isRenderedInStep: (step) => step >= 3,
    defaultOrder: 60,
  }, {
    id: 'finalCost_21',
    i18nKey: 'columns.finalCost',
    name: 'Slutkostnad',
    isRenderedInStep: (step) => step >= 3,
    defaultOrder: 62,
  }, {
    id: 'Äta_totalt_20',
    i18nKey: 'columns.additionsTotal',
    name: 'ÄTA totalt',
    isRenderedInStep: (step) => step >= 3,
    defaultOrder: 65,
  }, {
    id: 'Vald_leverantör_7',
    i18nKey: 'columns.chosenSupplier',
    name: 'Vald leverantör',
    isRenderedInStep: (step) => step > 2,
    defaultOrder: 70,
  }, {
    id: 'Förfrågningar_8',
    i18nKey: 'columns.bidRequests',
    name: 'Förfrågningar',
    isRenderedInStep: (step) => step <= 2,
    defaultOrder: 80,
  }, {
    id: 'Anbud_26',
    i18nKey: 'columns.bids',
    name: 'Anbud',
    isRenderedInStep: () => false,
    defaultOrder: 85,
  }, {
    id: 'Återstående_anbudstid_9',
    i18nKey: 'columns.timeLeft',
    name: 'Återstående anbudstid',
    isRenderedInStep: (step) => step === 1,
    defaultOrder: 90,
  }, {
    id: 'Förfrågan_skickas_senast_18',
    i18nKey: 'columns.quotationSentBy',
    name: 'Förfrågan skickas senast',
    isRenderedInStep: (step) => step === 1,
    defaultOrder: 95,
  }, {
    id: 'Svar_senast_10',
    i18nKey: 'columns.answersLatestBy',
    name: 'Svar senast',
    isRenderedInStep: (step) => step === 1,
    defaultOrder: 100,
  }, {
    id: 'Inköp_klart_17',
    i18nKey: 'columns.purchaseCompleted',
    name: 'Inköp klart',
    defaultOrder: 105,
  }, {
    id: 'Ledtid_19',
    i18nKey: 'columns.leadTime',
    name: 'Ledtid',
    defaultOrder: 108,
  }, {
    id: 'Leveransstart_11',
    i18nKey: 'columns.startDate',
    name: 'Leveransstart',
    defaultOrder: 110,
  }, {
    id: 'Leveransslut_12',
    i18nKey: 'columns.endDate',
    name: 'Leveransslut',
    defaultOrder: 120,
  }, {
    id: 'Ansvarig_13',
    i18nKey: 'columns.assignee',
    name: 'Ansvarig',
    defaultOrder: 130,
  }, {
    id: 'Utvärdering_14',
    i18nKey: 'columns.evaluation',
    name: 'Utvärdering',
    isRenderedInStep: (step) => step === 2,
    defaultOrder: 140,
  }, {
    id: 'Avtal_15',
    i18nKey: 'columns.contract',
    name: 'Avtal',
    isRenderedInStep: (step) => step >= 3,
    defaultOrder: 150,
  }, {
    id: 'Kommentar_16',
    i18nKey: 'columns.comments',
    name: 'Kommentarer',
    defaultOrder: 160,
  }, {
    id: 'Uppskattad_ÄTA_(%)_22',
    i18nKey: 'columns.estimatedAdditions',
    name: 'Uppskattad ÄTA (%)',
    defaultOrder: 33,
  }, {
    id: 'Inköpsmål_%_23',
    i18nKey: 'columns.purchaseGoal',
    name: 'Inköpsmål (%)',
    defaultOrder: 34,
  }, {
    id: 'Inköpsbudget_24',
    i18nKey: 'columns.purchaseBudget',
    name: 'Inköpsbudget',
    defaultOrder: 35,
  },
];

export class AppProjectPurchaseList extends React.Component {
  constructor(props) {
    super(props);
    const { t } = props;

    this.state = {
      showAgreementModal: false,
      wizard: [
        { step: 6, name: t('steps.purchasePlan', 'Inköpsplan') },
        { step: 1, name: t('steps.request', 'Förfrågan') },
        { step: 2, name: t('steps.evaluation', 'Utvärdering') },
        { step: 3, name: t('steps.negotiation', 'Förhandling') },
        { step: 4, name: t('steps.agreement', 'Avtal') },
      ],
      columns: this.initColumns(),
      filtersData: this.loadFilterPreferences(),
      showFilter: false,
      filterUsers: [],
      purchaseVersionData: [],
      hasLoadedVersionData: false,
      projectPriceRows: [],
      temporaryAreaBudget: {},
      temporaryAreaFinalCost: {},
      temporaryAreaLeadTime: {},
      isInitialLoading: true,
      // Bulk selection, only offered on the Inköpsplan tab (step 6) where every purchase is listed.
      selectedAreaIds: new Set(),
      bulkActionRunning: false,
      showBulkStatusModal: false,
      showBulkCoworkerModal: false,
      showBulkDeadlineModal: false,
      bulkDeadlineDate: null,
    };

    this.onRowClick = (e, rowData) => {
      this.props.history.push(`${this.props.location.pathname}/${rowData.areaId.slug}`)
    };
    this.columns = this.createColumns();
  }

  getColumnNameById(id) {
    const col = COLUMNS.find((column) => column.id === id);
    return this.props.t(col?.i18nKey, col?.name);
  }

  initColumns() {
    if (!isEmpty(appState.getProjectOverviewPreferences()?.columns)) {
      const mappedColumns = appState.getProjectOverviewPreferences().columns
        .filter(dbColumn => COLUMNS.find(column => column.id === dbColumn.id))
        .map(dbColumn => {
          const column = COLUMNS.find(column => column.id === dbColumn.id);
          return {
            ...dbColumn,
            name: this.getColumnNameById(column.id),
            static: column.static,
            isRenderedInStep: column.isRenderedInStep,
            defaultOrder: column.defaultOrder
          }
        });

      const columnsNotSaved = COLUMNS
        .filter(column => !appState.getProjectOverviewPreferences().columns.find(dbColumn => column.id === dbColumn.id))
        .map(column => ({
          ...column,
          name: this.getColumnNameById(column.id),
          show: true
        })).sort((a, b) => a.defaultOrder - b.defaultOrder);

      const sorted = [...COLUMNS].sort((a, b) => a.defaultOrder - b.defaultOrder);
      const existingOrders = mappedColumns.reduce((set, c) => set.add(c.defaultOrder), new Set());

      for (const column of columnsNotSaved) {
        let index = sorted.findIndex(c => c.id == column.id) - 1;
        while (index >= 0 && !existingOrders.has(sorted[index].defaultOrder)) {
          index--;
        }
        if (index >= 0) {
          const insertAt = mappedColumns.findIndex(c => c.id === sorted[index].id) + 1;
          mappedColumns.splice(insertAt, 0, column);
          existingOrders.add(column.defaultOrder);
        } else {
          mappedColumns.splice(0, 0, column);
          existingOrders.add(column.defaultOrder);
        }
      }

      return mappedColumns;
    } else {
      return COLUMNS.map(column => ({
        ...column,
        show: true,
        name: this.getColumnNameById(column.id)
      }));
    }
  }

  hasReRendered;

  // The in-flight (or settled) loadVersionData fetch. A bulk deadline send confirmed before the
  // data lands awaits this instead of being blocked by a disabled button.
  versionDataPromise;

  // The latest loadVersionData's controller: only that load may set state.
  versionDataAbortController;

  // Unmount aborts them all, superseded loads too, so none competes with the next page's requests.
  inFlightVersionDataControllers = new Set();

  /**
   * The version snapshots behind the request counts and the anbudstid countdown, per purchase.
   * Also re-run after anything that changes a deadline, since nothing else refetches this state.
   */
  loadVersionData() {
    // allSettled, not all: one failed request must not discard the areas that did load, and the
    // fetch must always settle — the request badges read hasLoadedVersionData and a racing bulk
    // deadline send awaits this promise, so an unhandled rejection would leave both stuck.
    // A failed area keeps `failed: true` rather than posing as an empty version list: empty means
    // "nothing was ever sent", which readers act on, while failed only means "we don't know".
    const controller = new AbortController();
    this.versionDataAbortController = controller;
    this.inFlightVersionDataControllers.add(controller);
    const projectAreas = this.props.currentProject.area;
    this.versionDataPromise = Promise.allSettled(projectAreas.map(async (area) => {
      const versionData = await ServiceProjects.getVersionData(this.props.currentProject.slug, area.areaId._id, controller.signal);
      return {
        areaId: area.areaId._id,
        versionData: versionData[0]?.versions ?? [],
      }
    })).then((results) => {
      this.inFlightVersionDataControllers.delete(controller);
      // Aborted on unmount: the rejections below are cancellations, not failures, and nothing
      // is left to read purchaseVersionData or hasLoadedVersionData.
      if (controller.signal.aborted) return undefined;

      const purchaseVersionData = results.map((result, i) => result.status === 'fulfilled'
        ? result.value
        : { areaId: projectAreas[i].areaId._id, versionData: [], failed: true });
      const failed = results.filter(result => result.status === 'rejected');
      if (failed.length > 0) {
        Sentry.captureException(failed[0].reason, {
          extra: {
            fetch: 'purchaseVersionData',
            failedAreaIds: purchaseVersionData.filter(entry => entry.failed).map(entry => entry.areaId),
            failedCount: failed.length,
          },
        });
      }
      // A superseded load still resolves for whoever awaits it, but must not overwrite newer state.
      if (this.versionDataAbortController === controller) {
        this.setState({
          purchaseVersionData,
          hasLoadedVersionData: true,
        })
      }
      // Resolve with the data itself: an awaiter judges eligibility from this, since the setState
      // above may not have committed by the time its await returns.
      return purchaseVersionData;
    })
    return this.versionDataPromise;
  }

  priceRowsAbortController;

  /** The Totalpris inputs per purchase: the row order and the values entered on custom rows. */
  loadPriceRows() {
    this.priceRowsAbortController?.abort();
    const controller = new AbortController();
    this.priceRowsAbortController = controller;
    return getProjectPriceRows(this.props.currentProject.slug, controller.signal)
      .then(projectPriceRows => {
        if (!controller.signal.aborted) this.setState({ projectPriceRows });
      })
      .catch(error => {
        if (controller.signal.aborted) return;
        Sentry.captureException(error, { extra: { fetch: 'projectPriceRows' } });
      });
  }

  bidsByPurchaseMemo;

  // Read by every row's render and sort comparison, so recomputed only when an input is replaced.
  getBidsByPurchase() {
    const { purchaseVersionData, projectPriceRows } = this.state;
    const areas = this.props.currentProject.area;
    const fallbackUnit = this.props.t('bids.fallbackUnit', 'kr');
    const inputs = [purchaseVersionData, projectPriceRows, areas, fallbackUnit];
    const memo = this.bidsByPurchaseMemo;
    if (!memo || inputs.some((input, i) => input !== memo.inputs[i])) {
      this.bidsByPurchaseMemo = {
        inputs,
        bids: bidsByPurchase(purchaseVersionData, projectPriceRows, areas, fallbackUnit),
      };
    }
    return this.bidsByPurchaseMemo.bids;
  }

  componentWillUnmount() {
    this.inFlightVersionDataControllers.forEach(controller => controller.abort());
    this.priceRowsAbortController?.abort();
  }

  async componentDidMount() {
    await appState.getUserDetails();
    if (!this.element) return;

    this.loadVersionData();
    this.loadPriceRows();

    this.setState({
      columns: this.initColumns(),
      filtersData: this.loadFilterPreferences(),
      filterUsers: this.props.users.filter(user => user.isActive).map(user => ({ label: user.label, value: user.value })),
      isInitialLoading: false,
    });
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.t !== nextProps.t) {
      const { t } = nextProps;

      this.state.wizard.forEach((state) => {
        switch (state.step) {
          case 6:
            state.name = t('steps.purchasePlan', 'Inköpsplan');
            return;
          case 1:
            state.name = t('steps.request', 'Förfrågan');
            return;
          case 2:
            state.name = t('steps.evaluation', 'Utvärdering');
            return;
          case 3:
            state.name = t('steps.negotiation', 'Förhandling');
            return;
          case 4:
            state.name = t('steps.agreement', 'Avtal');
            return;
          default:
            state.name = '';
        }
      });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    // The single purchase renders inside this component, so its Totalpris edits don't remount the table.
    if (prevProps.selectedArea && !this.props.selectedArea) this.loadPriceRows();

    if (this.props.step != prevProps.step) {
      this.columns = this.createColumns(); // force reordering
      this.setState({ columns: this.initColumns() });
    }

    // Drop the selection whenever the visible set changes. Keeping it would let a bulk action
    // hit purchases the user can no longer see.
    const visibleSetChanged =
      this.props.step != prevProps.step ||
      this.props.searchValue !== prevProps.searchValue ||
      this.state.filtersData !== prevState.filtersData;

    if (visibleSetChanged && this.state.selectedAreaIds.size > 0) {
      this.clearBulkSelection();
    } else if (this.props.currentProject !== prevProps.currentProject && this.state.selectedAreaIds.size > 0) {
      const liveIds = new Set((this.props.currentProject?.area ?? []).map(a => a.areaId?._id));
      if ([...this.state.selectedAreaIds].some(id => !liveIds.has(id))) {
        this.setState(prev => ({
          selectedAreaIds: new Set([...prev.selectedAreaIds].filter(id => liveIds.has(id))),
        }));
      }
    }
  }

  clearBulkSelection = () => {
    this.setState({ selectedAreaIds: new Set() });
  };

  toggleBulkSelect = (areaId) => {
    this.setState(prev => {
      const next = new Set(prev.selectedAreaIds);
      next.has(areaId) ? next.delete(areaId) : next.add(areaId);
      return { selectedAreaIds: next };
    });
  };

  toggleBulkSelectAll = (visibleAreaIds) => {
    this.setState(prev => ({
      selectedAreaIds: visibleAreaIds.length > 0 && prev.selectedAreaIds.size === visibleAreaIds.length
        ? new Set()
        : new Set(visibleAreaIds),
    }));
  };

  // The selected rows, resolved back to the project's area entries.
  getSelectedAreas() {
    const { selectedAreaIds } = this.state;
    return (this.props.currentProject?.area ?? []).filter(area => selectedAreaIds.has(area.areaId?._id));
  }

  /**
   * Members across the selected purchases, de-duplicated. `isInAll` tracks whether someone is in
   * every selected purchase, which is what decides if they can still be added to the rest.
   */
  getSelectedAreaMembers() {
    const areas = this.getSelectedAreas();
    const byId = new Map();

    areas.forEach(area => {
      const seen = new Set();
      (area.areaId?.members ?? []).forEach(member => {
        const id = member._id ?? member;
        if (seen.has(id)) return;
        seen.add(id);
        const entry = byId.get(id) ?? { _id: id, name: member.name, avatarUrl: member.avatarUrl, count: 0 };
        entry.count += 1;
        byId.set(id, entry);
      });
    });

    return [...byId.values()].map(({ _id, name, avatarUrl, count }) => ({
      _id,
      name,
      avatarUrl,
      isInAll: count === areas.length,
    }));
  }

  /**
   * What a bulk deadline extension would reach across the selected purchases: suppliers that were
   * sent a version and have not declined, in a purchase not already closed by a contract, and the
   * contact people they hold. Mirrors resolveEligibleExtensions in src/helpers/supplierDeadline.js
   * and hasBindingContract in src/helpers/purchaseStatus.js — the server re-resolves both before
   * writing; this sizes the send for the user and lets a confirmed send refuse, with a reason,
   * what the server would refuse anyway.
   *
   * `contacts` is what matters for the cap: each contact gets their own email.
   */
  getExtendableSelection(versionDataOverride) {
    // Version data is fetched per area after mount. Until it lands every supplier looks ineligible,
    // which is not the same as there being none — callers must not state the latter while loading.
    // The same distinction holds per area after settling: a selection touching an area whose fetch
    // failed is `unavailable`, not empty, because the recipient preview would under-count it.
    // The override is the settled fetch result, handed in by a submit that raced it — state may
    // not have committed at that point, so the override is authoritative and never `loading`.
    const versionData = versionDataOverride ?? this.state.purchaseVersionData;
    const loading = !versionDataOverride && !this.state.hasLoadedVersionData;

    // The counting itself lives in the util so it can be tested against the server's rules; this
    // only shapes component state into what it expects.
    const selection = summarizeExtendableSelection(this.getSelectedAreas()
      // A contracted purchase is finished; its bid deadline is no longer a live thing to move, and
      // the route skips it too. Dropped rather than marked unavailable: there is nothing unknown
      // about it, so it should not read as a purchase we failed to size up.
      .filter(area => !hasBindingContract(area))
      .map(area => {
        const entry = versionData.find(x => x.areaId === area.areaId?._id);
        return {
          areaId: String(area.areaId?._id),
          unavailable: !!entry?.failed,
          versions: entry?.versionData ?? [],
          suppliers: (area.suppliers ?? []).map(supplier => ({
            supplierId: String(supplier.supplierId?._id ?? supplier.supplierId),
            declined: supplier?.intentStatus?.intent === BidIntentStatus.DECLINED,
          })),
        };
      }));

    return { ...selection, loading };
  }

  handleBulkExtendDeadline = async ({ date, emailText }) => {
    const { t } = this.props;

    // The toolbar button no longer waits for the version fetch, so a send can be confirmed while
    // it is still in flight. Wait for it here — nothing goes out unsized — and refuse a selection
    // that settles unsendable with the reason. The modal closes on refusal because no retry from
    // it can succeed: the selection (or the page) has to change first. Returning without a result
    // keeps the modal's success toast silent — didExtendAnything reads the resolved value.
    const versionData = (await this.versionDataPromise) ?? [];
    const extendable = this.getExtendableSelection(versionData);
    const refusal = chooseBulkDeadlineRefusal(extendable);
    if (refusal) {
      this.setState({ showBulkDeadlineModal: false });
      NotificationManager.warning({
        unavailable: t('bulkActions.deadlineDataFailed',
          'Förfrågningarna kunde inte hämtas för alla valda upphandlingar. Ladda om sidan och försök igen.'),
        noRecipients: t('bulkActions.noExtendableSuppliers',
          'Ingen av de valda upphandlingarna har leverantörer med en skickad förfrågan som inte tackat nej. Avtalade upphandlingar berörs inte.'),
        overLimit: t('bulkActions.deadlineTooManyError',
          'Urvalet når {{requested}} kontaktpersoner men högst {{limit}} kan få utskick åt gången. Minska urvalet och försök igen.',
          { requested: extendable.contacts, limit: BULK_DEADLINE_MAX_RECIPIENTS }),
      }[refusal]);
      return;
    }

    const areaIds = this.getSelectedAreas().map(area => area.areaId._id);

    let result;
    try {
      // DateExtensionModal reports success/failure itself: a throw here surfaces as its error, and
      // the resolved value is judged by didExtendAnything before it announces success — the route
      // answers 200 even when it extended nobody. getBulkDeadlineErrorMessage below turns the
      // actionable rejections into specific text.
      result = await ServiceProjects.bulkUpdateSupplierDate(
        this.props.currentProject.slug,
        areaIds,
        { date, emailText },
      );
    } catch (error) {
      // The other bulk actions report through runBulkAction, which captures. This one bypasses it,
      // so capture here rather than leaving the largest action the only one without telemetry.
      Sentry.captureException(error, { extra: { bulkAction: 'extendDeadline', areaIds } });
      // A refusal still names the purchases the server could not resolve. Reporting them here is
      // the whole reason it sends them: otherwise they vanish with the rejection and the user
      // retries the same unusable selection.
      this.reportBulkDeadlineFailures(error?.response?.data);
      throw error;
    }

    const reportedFailures = this.reportBulkDeadlineFailures(result);

    // Not one supplier was extended. The success toast is already suppressed (shouldNotifySuccess
    // reads didExtendAnything), and the modal stays open with the selection intact so the same send
    // can be retried without reselecting.
    if (!didExtendAnything(result)) {
      if (reportedFailures) {
        // Everything the route attempted failed — worth knowing about.
        Sentry.captureException(new Error('Bulk deadline extension changed nothing'), {
          extra: { bulkAction: 'extendDeadline', areaIds, failed: result?.failed },
        });
      } else {
        // Nothing failed and nothing was extended: every selected purchase turned out to have
        // nobody eligible — declined, removed or contracted since the page loaded. A legitimate
        // outcome, not worth capturing, but it must still be said or the send ends in silence.
        NotificationManager.info(
          t('bulkActions.deadlineNothingExtended',
            'Ingen anbudstid ändrades. Leverantörerna kan ha tackat nej eller tagits bort sedan sidan laddades.')
        );
      }
      return result;
    }

    this.setState({ showBulkDeadlineModal: false });
    // Whole-purchase failures stay selected: nobody in them was emailed, so retrying them is one
    // click and sends for the first time. Partly-failed purchases are deliberately NOT retained —
    // the route re-extends (and re-emails) everyone in a purchase it is given, so keeping them
    // would turn the retry click into duplicate mail. Their suppliers are named in the toast and
    // can be handled through the single-supplier flow.
    const retained = selectionAfterBulkDeadline(result);
    if (retained) {
      this.setState({ selectedAreaIds: retained });
    } else {
      this.clearBulkSelection();
    }

    // The anbudstid countdown resolves from purchaseVersionData, which is otherwise only loaded on
    // mount and on leaving a purchase — without this the purchases just extended keep showing the
    // old date, some of them as expired, until then. Awaited so the success notification lands on
    // a refreshed list, but swallowed: the extension already went through, so a failed refetch
    // must not be reported as a failed send.
    await this.loadVersionData().catch(error => {
      Sentry.captureException(error, { extra: { bulkAction: 'extendDeadline', stage: 'refresh' } });
    });

    return result;
  };

  /**
   * Reports whatever the route could not do, from either a completed run or a refusal. `failed`
   * mixes per-supplier entries with whole-area ones, so each is reported as what it is instead of
   * counting an entire unprocessed purchase as a single supplier.
   *
   * Returns whether it said anything, so the caller can tell a reported outcome from a silent one.
   */
  reportBulkDeadlineFailures(carrier) {
    const { t } = this.props;
    const summary = summarizeBulkDeadlineFailures(carrier);
    const { failedSuppliers, failedAreas } = summary;

    if (failedSuppliers > 0) {
      NotificationManager.error(
        t('bulkActions.deadlineFailedSuppliers', 'Anbudstiden kunde inte ändras för {{count}} leverantörer: {{names}}', {
          count: failedSuppliers,
          names: this.formatFailureNames(summary.failedSupplierEntries.map(entry => this.resolveFailedSupplierName(entry))),
        }),
        t('bulkActions.failedTitle', 'Misslyckat')
      );
    }
    if (failedAreas > 0) {
      NotificationManager.error(
        t('bulkActions.deadlineFailedAreas', '{{count}} upphandlingar kunde inte behandlas: {{names}}', {
          count: failedAreas,
          names: this.formatFailureNames(summary.failedAreaIds.map(areaId => this.resolveAreaName(areaId))),
        }),
        t('bulkActions.failedTitle', 'Misslyckat')
      );
    }
    return failedSuppliers > 0 || failedAreas > 0;
  }

  resolveAreaName = (areaId) =>
    (this.props.currentProject?.area ?? [])
      .find(area => String(area.areaId?._id) === String(areaId))?.areaId?.name
    ?? this.props.t('bulkActions.unknownPurchase', 'okänd upphandling');

  // the purchase always rides along, since a supplier can sit in
  // several of the selected purchases and a bare name would not say which send failed.
  resolveFailedSupplierName = ({ areaId, supplierId }) => {
    const area = (this.props.currentProject?.area ?? [])
      .find(entry => String(entry.areaId?._id) === String(areaId));
    const supplier = (area?.suppliers ?? [])
      .find(entry => String(entry.supplierId?._id ?? entry.supplierId) === String(supplierId));
    const name = supplier?.supplierId?.name
      ?? this.props.t('bulkActions.unknownSupplier', 'okänd leverantör');
    return `${name} (${this.resolveAreaName(areaId)})`;
  };

  // Caps a name list so one toast cannot become a wall of text. `more`, not `count`, so i18next
  // does not go looking for plural variants of the key.
  formatFailureNames = (names, cap = 5) => {
    const shown = names.slice(0, cap).join(', ');
    const more = names.length - cap;
    return more > 0
      ? this.props.t('bulkActions.andMore', '{{shown}} och {{more}} till', { shown, more })
      : shown;
  };

  /**
   * Opens the existing supplier-selection page carrying the whole selection. The route still takes
   * one areaSlug so it is unchanged for the single-purchase case; the ids in router state are what
   * makes it bulk, and saveSuppliersHandler fans out over them.
   */
  handleBulkAddSuppliers = () => {
    const areas = this.getSelectedAreas();
    if (!areas.length) return;

    const orgSlug = appState.getCurrentOrgSlug();
    const projectSlug = this.props.currentProject.slug;
    this.props.history.push(
      `/${orgSlug}/projects/${projectSlug}/${areas[0].areaId.slug}/supplier-selection`,
      { bulkAreaIds: areas.map(area => area.areaId._id) }
    );
  };

  // Turns the two rejections the user can actually act on into specific text. Anything else falls
  // through to DateExtensionModal's generic "try again", which is right for transient failures.
  getBulkDeadlineErrorMessage = (error) => {
    const { t } = this.props;
    const reason = classifyBulkDeadlineError(error);

    if (reason?.kind === 'tooManyRecipients') {
      // reason.values is the server's own count and ceiling, forwarded as-is: quoting the local
      // copy of the limit would name a ceiling the server may no longer be enforcing.
      return t('bulkActions.deadlineTooManyError',
        'Urvalet når {{requested}} kontaktpersoner men högst {{limit}} kan få utskick åt gången. Minska urvalet och försök igen.',
        reason.values);
    }
    if (reason?.kind === 'tooManyPurchases') {
      return t('bulkActions.deadlineTooManyPurchases',
        'Du har valt fler upphandlingar än vad som kan behandlas i ett utskick. Minska urvalet och försök igen.');
    }
    return undefined;
  };

  /**
   * Runs `fn` for every selected purchase and reports the outcome per purchase rather than as a
   * single pass/fail — a bulk action that half-applied must not read as a success.
   * `fn` may return a skip reason; `skipMessages` maps each reason to its own notification so a
   * blocked purchase says why it was blocked instead of being lumped into a generic "skipped".
   */
  async runBulkAction(fn, { successKey, successFallback, skipMessages = {}, keepSelection = false, classifyRejection }) {
    const { t } = this.props;
    const areas = this.getSelectedAreas();
    if (!areas.length) return;

    this.setState({ bulkActionRunning: true });
    try {
      const items = areas.map(area => ({ id: area.areaId._id, name: area.areaId?.name ?? '' }));
      const results = await Promise.allSettled(areas.map(area => fn(area)));
      const outcome = bucketSettledResults(results, items, classifyRejection);

      outcome.failed.forEach(({ name, reason }) =>
        Sentry.captureException(reason, { extra: { bulkAction: successKey, areaName: name } }));

      if (outcome.changed > 0) {
        NotificationManager.success(t(successKey, successFallback, { count: outcome.changed }));
      }

      Object.entries(outcome.skippedByReason).forEach(([reason, skippedItems]) => {
        const message = skipMessages[reason];
        if (!message) return; // reasons without a message are silent no-ops (e.g. already correct)
        const { key, fallback, severity = 'info' } = message;
        const names = skippedItems.map(item => item.name);
        const text = t(key, fallback, { count: names.length, names: names.join(', ') });
        severity === 'error'
          ? NotificationManager.error(text, t('bulkActions.failedTitle', 'Misslyckat'))
          : NotificationManager.info(text);
      });

      if (outcome.failed.length) {
        NotificationManager.error(
          t('bulkActions.failed', '{{count}} upphandlingar misslyckades: {{names}}', {
            count: outcome.failed.length,
            names: outcome.failed.map(item => item.name).join(', '),
          }),
          t('bulkActions.failedTitle', 'Misslyckat')
        );
      }

      // A run can end with nothing changed, nothing failed and every skip silent — e.g. a
      // colleague removed the co-worker everywhere between page load and click. Total silence
      // after pressing a button reads as a bug, so say the honest minimum.
      if (needsNothingChangedNotice(outcome, Object.keys(skipMessages))) {
        NotificationManager.info(t('bulkActions.nothingChanged', 'Inga ändringar gjordes.'));
      }

      // The co-worker modal keeps managing the same purchases after each change, so it holds the
      // selection. One-shot actions keep only the failures — the error toast just named them, and
      // retrying is then one click; every caller is retry-safe (a purchase that actually changed
      // comes back as a skip, not a double-apply). A clean or fully skipped run clears.
      if (!keepSelection) {
        const retained = selectionAfterBulkRun(outcome);
        retained ? this.setState({ selectedAreaIds: retained }) : this.clearBulkSelection();
      }
    } catch (error) {
      // Unreachable by per-item failures (allSettled never rejects); this only guards a bug in the
      // reporting above. The selection is deliberately left as it was.
      Sentry.captureException(error, { extra: { bulkAction: successKey, stage: 'report' } });
    } finally {
      this.setState({ bulkActionRunning: false });
    }
  }

  renderBulkActions() {
    const { t } = this.props;
    const { bulkActionRunning, showBulkStatusModal, showBulkCoworkerModal, showBulkDeadlineModal } = this.state;
    // Count the purchases that will actually be acted on. A selected id can stop resolving to an
    // area if the project refreshes (e.g. a colleague deletes a purchase), and the bar must not
    // promise more than the action will touch.
    const selectedCount = this.getSelectedAreas().length;
    const busyTooltip = t('bulkActions.runningTooltip', 'En åtgärd pågår, vänta tills den är klar.');

    // The phases offered here mirror the per-purchase dropdown: Avtal (4) is reached through
    // contract signing, not picked manually.
    const statusOptions = this.state.wizard.filter(w => [1, 2, 3].includes(w.step));
    const coworkerOptions = (this.props.users ?? []).filter(u => u.isActive);
    const bulkMembers = this.getSelectedAreaMembers();
    const extendable = this.getExtendableSelection();

    return (
      <>
        <FloatingActionBar
          count={selectedCount}
          countLabel={t('bulkActions.countLabel', 'upphandlingar', { count: selectedCount })}
          onClose={this.clearBulkSelection}
          disabled={bulkActionRunning}
          disabledTooltip={busyTooltip}
          behind={showBulkDeadlineModal || showBulkStatusModal || showBulkCoworkerModal}
        >
          <FloatingActionBarButton
            icon={<PersonAddIcon style={{ fontSize: 16 }} />}
            label={t('bulkActions.addCoworker', 'Lägg till medarbetare')}
            onClick={() => this.setState({ showBulkCoworkerModal: true })}
            disabled={bulkActionRunning || !!showBulkStatusModal}
            disabledTooltip={bulkActionRunning ? busyTooltip : undefined}
          />
          <FloatingActionBarButton
            icon={<DomainIcon style={{ fontSize: 16 }} />}
            label={t('bulkActions.addSuppliers', 'Lägg till leverantörer')}
            onClick={this.handleBulkAddSuppliers}
            disabled={bulkActionRunning || selectedCount > BULK_ADD_MAX_PURCHASES}
            disabledTooltip={selectedCount > BULK_ADD_MAX_PURCHASES
              ? t('bulkActions.addSuppliersTooMany',
                'Högst {{limit}} upphandlingar kan få leverantörer tillagda åt gången. Minska urvalet och försök igen.',
                { limit: BULK_ADD_MAX_PURCHASES })
              : busyTooltip}
          />
          <FloatingActionBarDivider />
          <FloatingActionBarButton
            icon={<ScheduleIcon style={{ fontSize: 16 }} />}
            label={t('bulkActions.extendDeadline', 'Förläng anbudstid')}
            onClick={() => this.setState({ showBulkDeadlineModal: true })}
            disabled={bulkActionRunning || !!showBulkDeadlineModal}
            disabledTooltip={bulkActionRunning ? busyTooltip : undefined}
          />
          <FloatingActionBarDivider />
          <FloatingActionBarButton
            icon={<SwapHorizIcon style={{ fontSize: 16 }} />}
            label={t('bulkActions.changeStatus', 'Ändra status')}
            onClick={() => this.setState({ showBulkStatusModal: true })}
            disabled={bulkActionRunning || !!showBulkCoworkerModal}
            disabledTooltip={bulkActionRunning ? busyTooltip : undefined}
          />
        </FloatingActionBar>

        <Modal
          title={t('bulkActions.changeStatus', 'Ändra status')}
          show={!!showBulkStatusModal}
          setShow={v => this.setState({ showBulkStatusModal: v })}
          hasCloseButton
          unmountWhenHidden
        >
          <p className={styles.bulkModalText}>
            {t('bulkActions.changeStatusDescription', 'Välj vilken fas de {{count}} valda upphandlingarna ska flyttas till.', { count: selectedCount })}
          </p>
          <div className={styles.bulkStatusOptions}>
            {statusOptions.map(option => (
              <BtButton
                key={option.step}
                class="white"
                onClick={() => {
                  this.setState({ showBulkStatusModal: false });
                  this.handleBulkChangeStep(option.step);
                }}
              >
                {option.name}
              </BtButton>
            ))}
          </div>
        </Modal>

        {/* The same TeamBuilder modal used per purchase, in controlled mode. It lists the members
            of the selected purchases and removes across all of them; mode="project" only lifts the
            per-area team-size gate on the picker (the real limit is enforced per purchase in
            handleBulkAddCoworker), since the union can exceed one area's maximum. */}
        <TeamBuilder
          users={coworkerOptions}
          areaUsers={bulkMembers}
          mode="project"
          currentProject={this.props.currentProject}
          show={!!showBulkCoworkerModal}
          setShow={v => this.setState({ showBulkCoworkerModal: v })}
          onAddUser={this.handleBulkAddCoworker}
          onRemoveUser={this.handleBulkRemoveCoworker}
          busy={bulkActionRunning}
          // Only fully-covered members are unselectable; a partial member can still be added to
          // the purchases they're missing from.
          isOptionDisabled={option => bulkMembers.some(m => m._id === option?.value && m.isInAll)}
        />

        {/* The same modal used to extend one supplier's deadline. No version number is passed:
            each supplier is extended on their own latest version, so a single one would be wrong. */}
        <DateExtensionModal
          show={!!showBulkDeadlineModal}
          setShow={v => this.setState({ showBulkDeadlineModal: v })}
          defaultDate={new Date()}
          onSave={this.handleBulkExtendDeadline}
          data={{
            // Each supplier's email names THEIR purchase, so no single name is right here — a
            // placeholder, the same way the greeting stands in for the recipient. Summarising it as
            // "N valda upphandlingar" put a phrase in the preview that no real email ever contains.
            // The count is not lost: the InfoBox above states how many purchases the send covers.
            areaName: t('bulkActions.deadlineAreaPlaceholder', '<Upphandling>'),
            projectName: this.props.currentProject?.name ?? '',
          }}
          disableSubmit={extendable.overLimit}
          getErrorMessage={this.getBulkDeadlineErrorMessage}
          // A run that extended nobody must not announce "Sparat" over its own failure notices.
          shouldNotifySuccess={didExtendAnything}
          recipientNote={(
            <InfoBox
              // The modal no longer waits for the version fetch, so the preview says what is known
              // instead of counting the unknown as zero. Submitting in the first three states gets
              // the matching refusal (or the real counts) from handleBulkExtendDeadline, which
              // awaits the fetch before sending anything.
              description={extendable.loading ? (
                t('bulkActions.deadlineLoading', 'Hämtar förfrågningar för de valda upphandlingarna…')
              ) : extendable.unavailable > 0 ? (
                t('bulkActions.deadlineDataFailed', 'Förfrågningarna kunde inte hämtas för alla valda upphandlingar. Ladda om sidan och försök igen.')
              ) : extendable.suppliers === 0 ? (
                t('bulkActions.noExtendableSuppliers', 'Ingen av de valda upphandlingarna har leverantörer med en skickad förfrågan som inte tackat nej. Avtalade upphandlingar berörs inte.')
              ) : extendable.overLimit ? (
                <Trans
                  t={t}
                  i18nKey="bulkActions.deadlineOverLimit"
                  values={{ contacts: extendable.contacts, limit: BULK_DEADLINE_MAX_RECIPIENTS }}
                  components={{ b: <strong /> }}
                  defaults="Urvalet når <b>{{contacts}}</b> kontaktpersoner, men högst <b>{{limit}}</b> kan få utskick åt gången. Minska urvalet för att kunna skicka."
                />
              ) : (
                <Trans
                  t={t}
                  i18nKey="bulkActions.deadlineRecipients"
                  values={{
                    contacts: extendable.contacts,
                    suppliers: extendable.suppliers,
                    purchases: extendable.purchases,
                    limit: BULK_DEADLINE_MAX_RECIPIENTS,
                  }}
                  components={{ b: <strong /> }}
                  defaults="Skickas till <b>{{contacts}}</b> kontaktpersoner hos <b>{{suppliers}}</b> leverantörer i <b>{{purchases}}</b> upphandlingar. Leverantörer som tackat nej eller inte fått en förfrågan berörs inte, och inte heller avtalade upphandlingar. Högst <b>{{limit}}</b> kontaktpersoner per utskick."
                />
              )}
            />
          )}
        />
      </>
    );
  }

  handleBulkChangeStep = (step) => this.runBulkAction(
    async (area) => {
      const areaId = area.areaId._id;
      if (String(area.step ?? '1') === String(step)) return 'unchanged';

      // A contract pins a purchase to Avtal wherever it currently sits, so moving it anywhere
      // else would just be undone by checkContractSigning on the next load. Block it and say why.
      if (!canChangeStepTo(area, step)) return 'signed-contract';

      await ServiceProjects.dbChangeStep(this.props.currentProject.slug, areaId, step);
      try {
        // Local cache sync only. The server already committed, so a throw here must not put the
        // purchase in the failed bucket — a retry would then be skipped as 'unchanged', which
        // reads as a contradiction. The next fetch shows the true step regardless.
        ServiceProjects.updateStepInArea(this.props.currentProject.slug, areaId, step);
      } catch (error) {
        Sentry.captureException(error, { extra: { bulkAction: 'statusChanged', stage: 'localSync', areaId } });
      }
    },
    {
      successKey: 'bulkActions.statusChanged',
      successFallback: 'Status ändrad för {{count}} upphandlingar',
      skipMessages: {
        'unchanged': {
          key: 'bulkActions.alreadyInPhase',
          fallback: '{{count}} upphandlingar hade redan den statusen',
        },
        'signed-contract': {
          key: 'bulkActions.blockedBySignedContract',
          fallback: 'Kunde inte ändra status från Avtal för {{names}} eftersom det finns ett signerat avtal.',
          severity: 'error',
        },
      },
      // canChangeStepTo runs on page-load data, so a contract signed since then slips past it and
      // the server refuses instead. Same state, same message — not a generic failure.
      classifyRejection: reason =>
        reason?.response?.data?.error === 'error.stepLockedBySignedContract' ? 'signed-contract' : undefined,
    }
  );

  handleBulkAddCoworker = (user) => user && this.runBulkAction(
    async (area) => {
      const members = area.areaId.members ?? [];
      if (members.some(m => (m._id ?? m) === user._id)) return 'already-member';
      if (members.length >= MAX_TEAM_SIZE) return 'team-full';

      await ServiceUser.addMemberToArea(user._id, this.props.currentProject._id, area.areaId._id);
      try {
        // Local cache sync only — the server already committed, so a throw here must not put the
        // purchase in the failed bucket; a retry would then skip it as 'already-member'.
        ServiceProjects.addAreaMember(this.props.currentProject._id, area.areaId._id, user);
      } catch (error) {
        Sentry.captureException(error, { extra: { bulkAction: 'coworkerAdded', stage: 'localSync' } });
      }
    },
    {
      successKey: 'bulkActions.coworkerAdded',
      successFallback: 'Medarbetare tillagd i {{count}} upphandlingar',
      keepSelection: true,
      skipMessages: {
        // Quietly explains why the changed count is smaller than the selection; without it the
        // shrinkage looks like a bug. 'not-member' on remove stays silent — the modal's own
        // member list already shows who is where, and the nothingChanged fallback covers the
        // all-skip race.
        'already-member': {
          key: 'bulkActions.alreadyMember',
          fallback: 'Medarbetaren var redan tillagd i {{count}} upphandlingar',
        },
        'team-full': {
          key: 'bulkActions.teamFull',
          fallback: 'Teamet är fullt i {{names}}.',
        },
      },
    }
  );

  handleBulkRemoveCoworker = (userId) => this.runBulkAction(
    async (area) => {
      const members = area.areaId.members ?? [];
      if (!members.some(m => (m._id ?? m) === userId)) return 'not-member';

      await ServiceUser.removeMemberFromArea(userId, this.props.currentProject._id, area.areaId._id);
      try {
        // Same reasoning as the add: the server committed, the cache sync is best-effort.
        ServiceProjects.removeAreaMember(this.props.currentProject._id, area.areaId._id, userId);
      } catch (error) {
        Sentry.captureException(error, { extra: { bulkAction: 'coworkerRemoved', stage: 'localSync' } });
      }
    },
    {
      successKey: 'bulkActions.coworkerRemoved',
      successFallback: 'Medarbetare borttagen från {{count}} upphandlingar',
      keepSelection: true,
      // 'not-member' is silent — removing from a purchase they were never in is a no-op.
    }
  );

  filterAreas(item) {
    return item.isQuoteSent ? item.areaId : false;
  }

  async winnerChangeEventHandler(area, supplier, isRemoved) {
    if (!this.element) return;

    let currentProject = this.props.currentProject;
    let slug = currentProject.slug;
    let areaId = area._id;
    let supplierId = supplier && supplier._id;

    if (supplierId) {
      autosave(async () => {
        await ServiceProjects.dbRewardSupplier(
          slug,
          areaId,
          supplierId,
          !isRemoved
        );
        ServiceProjects.updateWinner(slug, areaId, supplierId, !isRemoved);
      })
    } else {
      console.error("Price can't be updated without supplierId.");
    }

    var collection = [];
    currentProject.area.forEach(val => {
      val.suppliers.forEach(s => {
        if ((s.supplierId?._id ?? s.supplierId) == supplierId) s.reward = !isRemoved;
        if (s.reward) collection.push(s.supplierId);
      });
    });

    if (this.props.winnerChangeEvent) {
      this.props.winnerChangeEvent(this, [...collection]);
    }
  }

  async changeStepEventHandler(area, skipStepChange = false, stepId) {
    let currentProject = this.props.currentProject;
    let slug = currentProject.slug;
    let areaId = area?._id;

    if (this.props.onStepChange && !skipStepChange) this.props.onStepChange(stepId);
    await ServiceProjects.dbChangeStep(slug, areaId, stepId);
    ServiceProjects.updateStepInArea(slug, areaId, stepId);
  }

  async dateChangeEventHandler(area, dateEnd) {
    if (!this.element) return;

    let currentProject = this.props.currentProject;
    let slug = currentProject.slug;
    let areaId = area._id;

    await ServiceProjects.dbUpdateEndDate(slug, areaId, dateEnd);
    ServiceProjects.updateEndDateInArea(slug, areaId, dateEnd);
  }

  async changeAreaBudget(area, budget) {
    if (!this.element) return;
    autosave(async () => {
      const budgetValue = budget.target.value;

      let currentProject = this.props.currentProject;
      let slug = currentProject.slug;
      let areaId = area._id;

      await ServiceProjects.dbUpdateAreaBudget(slug, areaId, budgetValue);
      ServiceProjects.updateBudgetInArea(slug, areaId, budgetValue);
    });
  }

  async changeAreaEstimatedContractSum(area, estimatedContractSum) {
    if (!this.element) return;
    autosave(async () => {
      const estimatedContractSumValue = estimatedContractSum.target.value;

      let currentProject = this.props.currentProject;
      let slug = currentProject.slug;
      let areaId = area._id;

      await ServiceProjects.dbUpdateEstimatedContractSum(slug, areaId, estimatedContractSumValue);
      ServiceProjects.updateEstimatedContractSumInArea(slug, areaId, estimatedContractSumValue);
    })
  }

  createColumns() {
    const { t } = this.props;

    const getWinnerInfoFromRow = (rowData) => {
      const winner = rowData.suppliers.find(s => s.reward);
      return {
        name: winner?.supplierId.name ?? "–",
        frameworkAgreement: hasValidFile(winner?.supplierId?.frameworkAgreements ?? []),
        organizationNumber: winner?.supplierId?.organizationNumber,
      };
    }

    const getContractSumFromRow = (rowData) => {
      const contractsSum = rowData.contracts?.filter(contract => !!contract?.signedAt)?.reduce((sum, c) => sum + parseAmount(c.amount ?? ''), 0) ?? 0;
      const manualContractsSum = rowData.manualContract?.reduce((sum, c) => sum + parseAmount(c.amount ?? ''), 0) ?? 0;
      const sum = contractsSum + manualContractsSum;
      return sum;
    }

    const getProfitDataFromRow = (rowData) => {
      const cost = getContractSumFromRow(rowData);
      const additionsFactor = (100 + parseAmount(rowData.estimatedAdditionsPercent ?? "0")) / 100;
      const budget = parseAmount(rowData.budget ?? '') / additionsFactor;
      if (budget > 0 && cost > 0) {
        return [budget - cost, budget];
      }
    }

    const getLongestDateExtensionFromRow = (rowData) => {
      if (!rowData.endDate) return null;

      const areaSuppliers = rowData?.suppliers;

      let longestExtension = moment(rowData.endDate);
      areaSuppliers.forEach(supplier => {
        if (supplier.date && moment(supplier.date).isAfter(longestExtension)) {
          longestExtension = moment(supplier.date);
        }
      })

      return longestExtension;
    }

    const genericCompare = (a, b) => {
      if (a < b) return -1;
      if (a > b) return 1;
      return 0;
    }

    const compareAmounts = (a, b, order) => {
      const afterEverything = order == "asc" ? ""+Number.MAX_SAFE_INTEGER : ""+Number.MIN_SAFE_INTEGER;
      return genericCompare(parseAmount(a || afterEverything), parseAmount(b || afterEverything));
    }

    const differenceBetweenFinalCostAndContractSum = (area) => {
      const contractSum = getContractSumFromRow(area);
      let difference;
      if (contractSum && area?.finalCost && area?.finalCost != 0) {
        difference = parseAmount(area.finalCost) - contractSum;
      }
      return difference;
    }

    return [
      {
        id: 'Upphandling_1',
        title: this.getColumnNameById('Upphandling_1'),
        field: "areaId.name",
        render: rowData => {
          const count = rowData.suppliers.reduce((sum, s) => sum + s.supplierId.notification?.reduce((sum, n) => sum + (n?.count ?? 0), 0), 0)
          return (
            <span style={{ display: "flex", gap: 8, minWidth: '200px', alignItems: 'center', justifyContent: 'space-between' }}>
              <span style={{ color: 'var(--gray-900)', fontSize: 'var(--fontSize-16)', fontWeight: 'var(--weight-600)' }}>{rowData.areaId.name}</span>
              <NotificationCounter counter={count} />
            </span>
          );
        }
      },
      {
        id: 'Kontonummer_25',
        title: this.getColumnNameById('Kontonummer_25'),
        field: "areaId.accountNumber",
        render: rowData => (
          <span style={{ color: 'var(--gray-700)' }}>{rowData.areaId.accountNumber || '–'}</span>
        ),
        customSort: (a, b, _, order) => {
          const hasA = a.areaId.accountNumber?.trim();
          const hasB = b.areaId.accountNumber?.trim();

          if (!hasA && !hasB) return 0;

          if (order === 'asc') {
            if (!hasA) return 1;
            if (!hasB) return -1;
          } else {
            if (!hasA) return -1;
            if (!hasB) return 1;
          }

          return parseFloat(a.areaId.accountNumber) - parseFloat(b.areaId.accountNumber);
        },
      },
      {
        id: 'Budget_3',
        title: this.getColumnNameById('Budget_3'),
        field: "budget",
        render: rowData => (
          <TableField
            value={rowData?.budget}
            onBlur={async (value) => {
              if (value != rowData?.budget) {
                await ServiceProjects.dbUpdateAreaBudget(this.props.currentProject.slug, rowData.areaId._id, value);
                ServiceProjects.updateBudgetInArea(this.props.currentProject.slug, rowData.areaId._id, value);
              }
            }}
          />
        ),
        customSort: (a, b, _, order) => compareAmounts(a.budget, b.budget, order),
      },
      {
        id: 'Ansvarig_13',
        title: this.getColumnNameById('Ansvarig_13'),
        customSort: (a, b) => genericCompare(a.areaId.members?.length ?? 0, b.areaId.members?.length ?? 0),
        render: rowData => (
          <TeamBuilder users={this.props.users} areaUsers={rowData.areaId.members} currentProject={this.props.currentProject} areaId={rowData.areaId._id} />
        ),
      },
      {
        id: 'Vald_leverantör_7',
        title: this.getColumnNameById('Vald_leverantör_7'),
        customSort: (x, y) => {
          const a = getWinnerInfoFromRow(x).name;
          const b = getWinnerInfoFromRow(y).name;
          return genericCompare(a, b);
        },
        render: rowData => {
          const { name, frameworkAgreement, organizationNumber } = getWinnerInfoFromRow(rowData);
          const url = appState._getCurrentOrgUrl();
          const queryString = organizationNumber ? organizationNumber : name;

          let active = false;
          let end;
          const pickedDate = frameworkAgreement?.validUntilDate;
          if (pickedDate) {
            end = new Date(pickedDate);
            end.setHours(23, 59, 59, 999);
            active = new Date() < end;
          }
          const color = active ? 'var(--green-500)' : 'var(--red-300)';

          return (
            <span style={{ whiteSpace: 'nowrap', display: 'flex' }}>
              {frameworkAgreement && (frameworkAgreement.file || frameworkAgreement.validUntilDate || frameworkAgreement.comment) &&
                <ContractIcon style={{ marginRight: "10px", marginLeft: 0, width: "20px", verticalAlign: "middle" }} color={frameworkAgreement?.validUntilDate ? color : 'var(--green-500)'} />
              }
              <span
                style={{ textDecoration: name !== '–' && queryString ? 'underline' : 'normal' }}
                onClick={queryString ? (e) => {
                  e.stopPropagation();
                  this.props.history.push(`${url}/supplier-database`, { q: queryString })
                } : undefined}
              >
                {name}
              </span>
            </span>
          )
        }
      },
      {
        id: 'Avtal_15',
        title: this.getColumnNameById('Avtal_15'),
        sorting: false,
        render: rowData => {
          const contracts = rowData.contracts ?? [];
          const manualContracts = rowData.manualContract ?? [];
          const done = contracts.filter(contract => contract?.signedAt).concat(manualContracts);
          const pending = contracts.filter(contract => {
            if (contract?.signedAt) return false;
            return !['canceled', 'timedout', 'rejected', 'document_error'].includes(contract?.lastStatus);
          });
          const canceled = contracts.filter(contract => {
            if (contract?.signedAt) return false;
            return ['canceled', 'timedout', 'rejected', 'document_error'].includes(contract?.lastStatus);
          });

          return (
            <div style={{ display: "flex", gap: '12px', paddingRight: '16px' }}>
              {pending.length > 0 && (
                <TooltipContainer key="pending" renderReferenceComponent={(className, ref) => <Badge className={className} ref={ref} bgColor='var(--yellow-50)' color='var(--yellow-700)' value={pending.length} icon={<CirclePendingIcon fill='var(--yellow-700)' width='16px' height='16px' />} />}>
                  <ContractBadgeContent contracts={pending} status='PENDING' />
                </TooltipContainer>
              )}
              {done.length > 0 && (
                <TooltipContainer key="done" renderReferenceComponent={(className, ref) => <Badge className={className} ref={ref} bgColor='var(--green-50)' color='var(--green-700)' value={done.length} icon={<CircleCheckIcon fill='var(--green-700)' width='16px' height='16px' />} />}>
                  <ContractBadgeContent contracts={done} status='DONE' />
                </TooltipContainer>
              )}
              {canceled.length > 0 && (
                <TooltipContainer key="canceled" renderReferenceComponent={(className, ref) => <Badge className={className} ref={ref} bgColor='var(--red-50)' color='var(--red-700)' value={canceled.length} icon={<CircleXIcon fill='var(--red-700)' width='16px' height='16px' />} />}>
                  <ContractBadgeContent contracts={canceled} status='CANCELED' />
                </TooltipContainer>
              )}
            </div>
          );
        },
      },
      {
        id: 'Kontraktssumma_4',
        title: this.getColumnNameById('Kontraktssumma_4'),
        customSort: (x, y) => {
          const a = getContractSumFromRow(x);
          const b = getContractSumFromRow(y);
          return genericCompare(a, b);
        },
        render: rowData => {
          const sum = getContractSumFromRow(rowData);
          return sum > 0 ? <span style={{ whiteSpace: 'nowrap' }}>{t('amount', '{{amount}} kr', { amount: formatAmount(sum) })}</span> : "–";
        }
      },
      {
        id: 'Inköpsvinst_(SEK)_5',
        title: this.getColumnNameById('Inköpsvinst_(SEK)_5'),
        customSort: (x, y) => {
          const xData = getProfitDataFromRow(x);
          const a = xData ? xData[0] : 0;
          const yData = getProfitDataFromRow(y);
          const b = yData ? yData[0] : 0;
          return genericCompare(a, b);
        },
        render: rowData => {
          const data = getProfitDataFromRow(rowData);
          const contractSum = getContractSumFromRow(rowData);

          if (data) {
            const [profit, budget] = data;
            return (
              <div style={{ display: "flex", justifyContent: "space-around", alignItems: "center", gap: "12px" }}>
                <TooltipContainer renderReferenceComponent={(className, ref) => (
                  <span className={className} ref={ref} style={{ whiteSpace: 'nowrap' }}>{t('amount', '{{amount}} kr', { amount: formatAmount(profit) })}</span>
                )}>
                  <div style={{ maxWidth: "400px" }}>
                    {t(
                      'profit.tooltip',
                      'Skillnaden mellan budget justerad för uppskattad ÄTA och kontraktssumma ({{budget}} kr - {{contractSum}} kr).',
                      { budget: formatAmount(budget), contractSum: formatAmount(contractSum) }
                    )}
                  </div>
                </TooltipContainer>
              </div>
            );
          } else {
            return "–";
          }
        }
      },
      {
        id: 'Inköpsvinst_(%)_6',
        title: this.getColumnNameById('Inköpsvinst_(%)_6'),
        customSort: (x, y) => {
          let a = 0, b = 0;
          const xData = getProfitDataFromRow(x);
          if (xData) {
            const [profit, budget] = xData;
            a = Math.round(profit / budget * 10000) / 100;
          }
          const yData = getProfitDataFromRow(y);
          if (yData) {
            const [profit, budget] = yData;
            b = Math.round(profit / budget * 10000) / 100;
          }
          return genericCompare(a, b);
        },
        render: rowData => {
          const data = getProfitDataFromRow(rowData);
          if (data) {
            const [profit, budget] = data;
            const percentage = formatAmount(Math.round(profit / budget * 10000) / 100);
            return (
              <span style={{ whiteSpace: 'nowrap' }}>{t('percentage', '{{percentage}} %', { percentage })}</span>
            );
          }
          return '–';
        }
      },
      {
        id: 'Inköp_klart_17',
        title: this.getColumnNameById('Inköp_klart_17'),
        field: 'purchaseCompleted',
        render: rowData => {
          return (
            <TableDatePicker
              date={rowData?.purchaseCompleted}
              onChange={async date => {
                await ServiceProjects.updateAndAutocompleteFields(this.props.currentProject.slug, rowData.areaId.slug, 'purchaseCompleted', {
                  purchaseCompleted: date,
                  leadTime: rowData.leadTime,
                  productionStartsAt: rowData.productionStartsAt,
                });
              }}
            />
          )
        }
      },
      {
        id: 'Förfrågan_skickas_senast_18',
        title: this.getColumnNameById('Förfrågan_skickas_senast_18'),
        field: 'quotationSentBy',
        render: rowData => {
          return (
            <TableDatePicker
              date={rowData?.quotationSentBy}
              onChange={async date => {
                await ServiceProjects.updateProjectAreaQuotationSentBy(this.props.currentProject.slug, rowData.areaId.slug, date);
              }}
            />
          )
        }
      },
      {
        id: 'Ledtid_19',
        title: this.getColumnNameById('Ledtid_19'),
        field: 'leadTime',
        render: rowData => {
          const areaLeadTime = (rowData?.leadTime || rowData?.leadTime === 0) ? rowData?.leadTime : null;
          const { value, updating } = this.state.temporaryAreaLeadTime[rowData.areaId._id] || {};
          const temporaryLeadTime = updating ? value : areaLeadTime;
          const leadTimeInWeeks = (temporaryLeadTime || temporaryLeadTime === 0) ? temporaryLeadTime / (1000 * 60 * 60 * 24 * 7) : undefined;

          return (
            <TableField
              value={leadTimeInWeeks}
              originalValue={rowData?.leadTime}
              setValue={(value) => {
                this.setState({ temporaryAreaLeadTime: { ...this.state.temporaryAreaLeadTime, [rowData.areaId._id]: value } })
              }}
              onBlur={async (value) => {
                await ServiceProjects.updateAndAutocompleteFields(this.props.currentProject.slug, rowData.areaId.slug, 'leadTime', {
                  purchaseCompleted: rowData.purchaseCompleted,
                  leadTime: value,
                  productionStartsAt: rowData.productionStartsAt,
                });
              }}
              isLeadTime
            />
          )
        }
      },
      {
        id: 'finalCost_21',
        title: this.getColumnNameById('finalCost_21'),
        customSort: (x, y) => {
          return genericCompare(parseAmount(x?.finalCost ?? ''), parseAmount(y?.finalCost ?? ''));
        },
        render: rowData => {
          const areaFinalCost = (rowData?.finalCost || rowData?.finalCost === 0) ? rowData?.finalCost : null;
          const { value, updating } = this.state.temporaryAreaFinalCost[rowData.areaId._id] || {};
          const temporaryFinalCost = updating ? value : areaFinalCost;
          return (
            <TableField
              value={temporaryFinalCost}
              originalValue={rowData?.finalCost}
              setValue={(value) => this.setState({ temporaryAreaFinalCost: { ...this.state.temporaryAreaFinalCost, [rowData.areaId._id]: value } })}
              onBlur={async (value) => {
                await ServiceProjects.updateProjectAreaFinalCost(this.props.currentProject.slug, rowData.areaId.slug, value);
              }}
            />
          );
        }
      },
      {
        id: 'Äta_totalt_20',
        title: this.getColumnNameById('Äta_totalt_20'),
        customSort: (x, y) => {
          const a = differenceBetweenFinalCostAndContractSum(x);
          const b = differenceBetweenFinalCostAndContractSum(y);

          return genericCompare(a, b);
        },
        render: rowData => {
          const difference = differenceBetweenFinalCostAndContractSum(rowData);
          return <span style={{ whiteSpace: 'nowrap' }}>{difference !== undefined ? t('amount', '{{amount}} kr', { amount: formatAmount(difference) || '0' }) : '–'}</span>
        }
      },
      {
        id: 'Förfrågningar_8',
        title: this.getColumnNameById('Förfrågningar_8'),
        sorting: false,
        render: rowData => {
          const versions = rowData?.versionData;
          const areaSuppliers = rowData?.suppliers;

          const latestVersionPerSupplier = {};

          versions.forEach(version => {
            const refVersion = version.refVersion;
            const suppliers = version?.suppliers?.filter(versionSupplier => areaSuppliers.find(areaSupplier => areaSupplier.supplierId._id === versionSupplier.supplierId));
            suppliers.forEach(supplier => {
              if (!latestVersionPerSupplier[supplier.supplierId] || refVersion > latestVersionPerSupplier[supplier.supplierId].refVersion) {
                latestVersionPerSupplier[supplier.supplierId] = version;
              }
            })
          });

          const totalStatus = Object.entries(latestVersionPerSupplier).map(([id, version]) => {
            const submitted = version.supplierBids.find(x => x.supplierId === id);
            if (submitted) {
              return 'submitted';
            }
            let status = 0;
            // intent is now an absolute value on the project area supplier, not per version/member
            const areaSupplier = areaSuppliers.find(as => as.supplierId._id === id);
            const intent = areaSupplier?.intentStatus?.intent;
            if (intent === 'DECLINED') {
              status = 3;
            } else if (intent === 'ACCEPTED') {
              status = 2;
            } else if (version.suppliers.some(supplierMember => supplierMember.supplierId === id && supplierMember.isSeen)) {
              status = 1;
            }

            switch (status) {
              case 0:
                return 'not-seen';
              case 1:
                return 'seen';
              case 2:
                return 'accepted';
              case 3:
                return 'declined';
            }
          }).reduce((total, current) => {
            if (!total[current]) {
              total[current] = 1;
            } else {
              total[current] += 1;
            }
            return total;
          }, {});

          const loading = !this.state.hasLoadedVersionData;
          let submitted = totalStatus['submitted'] ?? (loading ? '' : 0);
          let declined = totalStatus['declined'] ?? (loading ? '' : 0);
          let accepted = totalStatus['accepted'] ?? (loading ? '' : 0);
          let seen = totalStatus['seen'] ?? (loading ? '' : 0);
          let notSeen = totalStatus['not-seen'] ?? (loading ? '' : 0);
          const numberOfSuppliersWithAtLeastOneVersion = Object.keys(latestVersionPerSupplier)?.length ?? 0;

          return (
            <div className='requestsContainer' style={{ display: 'flex', gap: '8px' }}>
              {(numberOfSuppliersWithAtLeastOneVersion > 0 || loading) && (
                <>
                  <TooltipContainer key="total" renderReferenceComponent={(className, ref) => <Badge loading={loading} className={className} ref={ref} value={loading ? '' : numberOfSuppliersWithAtLeastOneVersion} />}>
                    {!loading && <span>{t('requests.tooltip.numberOfSuppliersWithAtLeastOneVersion', 'Förfrågningar')}</span>}
                  </TooltipContainer>

                  <TooltipContainer key="notSeen" renderReferenceComponent={(className, ref) => <Badge loading={loading} className={className} ref={ref} value={notSeen} icon={<OpenedEyeIcon fill='var(--gray-300)' height='18px' />} />}>
                    {!loading && <span>{t('requests.tooltip.notSeen', 'Anbudssidan ej öppnad')}</span>}
                  </TooltipContainer>

                  <TooltipContainer key="seen" renderReferenceComponent={(className, ref) => <Badge loading={loading} className={className} ref={ref} value={seen} icon={<OpenedEyeIcon fill='var(--gray-700)' height='18px' />} />}>
                    {!loading && <span>{t('requests.tooltip.seen', 'Leverantören har öppnat anbudssidan')}</span>}
                  </TooltipContainer>

                  <TooltipContainer key="accepted" renderReferenceComponent={(className, ref) => <Badge loading={loading} className={className} ref={ref} value={accepted} icon={<CircleCheckIcon fill='var(--gray-700)' height='16px' />} />}>
                    {!loading && <span>{t('requests.tooltip.accepted', 'Avser att lämna anbud')}</span>}
                  </TooltipContainer>

                  <TooltipContainer key="declined" renderReferenceComponent={(className, ref) => <Badge loading={loading} className={className} ref={ref} value={declined} icon={<CircleXIcon style={{ fill: 'var(--gray-700)', height: '16px' }} />} />}>
                    {!loading && <span>{t('requests.tooltip.declined', 'Avser att inte lämna anbud')}</span>}
                  </TooltipContainer>

                  <TooltipContainer key="submitted" renderReferenceComponent={(className, ref) => <Badge loading={loading} className={className} ref={ref} value={submitted} icon={<CircleDollarIcon style={{ fill: 'var(--gray-700)' }} />} />}>
                    {!loading && <span>{t('requests.tooltip.submitted', 'Leverantören har lämnat anbud')}</span>}
                  </TooltipContainer>
                </>
              )}
            </div>
          );
        }
      },
      {
        id: 'Anbud_26',
        title: <PurchaseBidsTitle />,
        customSort: (a, b) =>
          compareBidCounts(this.getBidsByPurchase(), a.areaId._id, b.areaId._id),
        render: rowData => {
          const bids = this.getBidsByPurchase().get(rowData.areaId._id);
          return bids ? <PurchaseBids bids={bids} /> : null;
        }
      },
      {
        id: 'Återstående_anbudstid_9',
        title: this.getColumnNameById('Återstående_anbudstid_9'),
        customSort: (x, y) => {
          const xDate = getLongestDateExtensionFromRow(x);
          const a = xDate !== null ? getDaysLeft(xDate) : 0;
          const yDate = getLongestDateExtensionFromRow(y);
          const b = yDate !== null ? getDaysLeft(yDate) : 0;
          return genericCompare(a, b);
        },
        render: rowData => {
          const longestExtension = getLongestDateExtensionFromRow(rowData);
          if (longestExtension === null) return;

          const daysLeft = getDaysLeft(longestExtension);

          return (
            <TooltipContainer
              renderReferenceComponent={(className, ref) =>
                <div className={className} ref={ref} style={{ width: 'fit-content', textAlign: "right", whiteSpace: 'nowrap' }}>
                  {
                    isNaN(+daysLeft) ? (
                      daysLeft
                    ) : (
                      t(
                        'extensionDate.daysLeft',
                        '{{count}} dagar',
                        {
                          context: +daysLeft < 0 ? 'expired' : null,
                          count: Math.abs(+daysLeft)
                        }
                      )
                    )
                  }
                </div>
              }
            >
              <div style={{ whiteSpace: 'nowrap' }}>
                {t(
                  'extensionDate.tooltip',
                  'Anbudstiden går ut {{date}}',
                  {
                    context: daysLeft < 0 ? 'expired' : null,
                    date: longestExtension.format('YYYY-MM-DD')
                  }
                )}
              </div>
            </TooltipContainer>
          );
        }
      },
      {
        id: 'Utvärdering_14',
        title: this.getColumnNameById('Utvärdering_14'),
        sorting: false,
        render: rowData => {
          if (rowData.attachment?.length > 0) {
            const areaId = rowData.areaId._id;
            const projectId = this.props.currentProject._id;
            const evaluation = rowData.attachment[rowData.attachment.length - 1];
            return (
              <div onClick={e => e.stopPropagation()}>
                <File file={evaluation.file} fileName={evaluation.fileName} scope={FileScope.ProjectEvaluation} scopeOptions={{ projectId, areaId }} />
              </div>
            )
          }
        }
      }, {
        id: 'Kommentar_16',
        title: this.getColumnNameById('Kommentar_16'),
        sorting: false,
        render: rowData => {
          return (
            <div key={rowData.areaId.slug} onClick={(e) => e.stopPropagation()} style={{ cursor: 'default' }}>
              <ConversationModal
                title={t('comments.title', 'Kommentarer')}
                fetchConversation={async () => await ServiceProjects.getProjectAreaComments(this.props.currentProject.slug, rowData.areaId.slug)}
                updateConversation={async (content) => await ServiceProjects.updateProjectAreaComments(this.props.currentProject.slug, rowData.areaId.slug, content)}
                editMessage={async (messageId, content) => await ServiceProjects.editProjectAreaComment(this.props.currentProject.slug, rowData.areaId.slug, messageId, content)}
                deleteMessage={async (messageId) => await ServiceProjects.deleteProjectAreaComment(this.props.currentProject.slug, rowData.areaId.slug, messageId)}
                render={(hasContent, content, openModal, count, author, date) => {
                  return <ConversationButton openModal={openModal} hasContent={hasContent} content={content} count={count} author={author} date={date} />;
                }}
              />
            </div>
          )
        },
      }, {
        id: 'Status_2',
        title: this.getColumnNameById('Status_2'),
        field: 'step',
        render: rowData => <div>{this.state.wizard.find(phase => phase.step == rowData.step)?.name}</div>
      },
      {
        id: 'Svar_senast_10',
        title: this.getColumnNameById('Svar_senast_10'),
        field: 'answersLatestBy',
        render: rowData => {
          const versions = rowData?.versionData;
          const areaSuppliers = rowData?.suppliers;

          let latestExpirationDate;
          if (rowData?.answersLatestBy && !_.isEmpty(versions)) {
            // Per supplier: latest version they're included in -> that version's extension-or-default
            // expiry; keep the max across the area's suppliers. (See util/supplierDeadline.)
            areaSuppliers.forEach(areaSupplier => {
              const resolved = resolveSupplierExpiry(areaSupplier.supplierId._id, versions);
              if (!resolved) return;
              const selectedDate = resolved.expiry;
              if (!latestExpirationDate || moment(selectedDate).isAfter(latestExpirationDate)) {
                latestExpirationDate = selectedDate;
              }
            })
          }

          const latestExpirationIsAfterplannedDate = rowData?.answersLatestBy && !_.isEmpty(versions) && moment(latestExpirationDate).isAfter(rowData.answersLatestBy, 'day');

          return (
            <TableDatePicker
              date={rowData?.answersLatestBy}
              warningMessage={latestExpirationIsAfterplannedDate
                ? <div style={{ maxWidth: '250px', whiteSpace: 'normal' }}>
                  {t(
                    'answersLatestBy.warningMessage',
                    'Minst en leverantör har fått en förfrågan med senare anbudsdatum än detta ({{latestExpirationDate}}).',
                    { latestExpirationDate: moment(latestExpirationDate).locale('sv').format('D MMMM YYYY') })
                  }
                </div>
                : ''
              }
              onChange={async date => {
                await ServiceProjects.updateProjectAreaAnswersLatestBy(this.props.currentProject.slug, rowData.areaId.slug, date);
              }}
            />
          )
        }
      },
      {
        id: 'Leveransstart_11',
        title: this.getColumnNameById('Leveransstart_11'),
        field: 'productionStartsAt',
        render: rowData => {
          const date = rowData?.productionStartsAt && moment(rowData?.productionStartsAt);

          const purchaseCompleted = rowData.purchaseCompleted;
          const leadTime = rowData.leadTime;

          let errorMessage = '';
          if (date && purchaseCompleted && (leadTime || leadTime === 0)) {
            const calculatedLeadTime = moment(date).diff(purchaseCompleted, 'milliseconds');
            const calculatedLeadTimeInWeeks = calculatedLeadTime / (1000 * 60 * 60 * 24 * 7);
            const leadTimeInWeeks = leadTime / (1000 * 60 * 60 * 24 * 7);
            const leadTimesDontMatch = calculatedLeadTimeInWeeks < leadTimeInWeeks;
            const purchaseCompletedDateIsAfterProductionsStartsDate = moment(purchaseCompleted).isSameOrAfter(date);
            errorMessage = (leadTimesDontMatch || purchaseCompletedDateIsAfterProductionsStartsDate) ? (
              <div style={{ maxWidth: '200px', whiteSpace: 'normal' }}>
                {t(
                  'productionStartsAt.errorMessage',
                  'Inte tillräckligt med tid mellan inköp klart och leveransstart (med {{leadTimeInWeeks}} veckors ledtid)',
                  { leadTimeInWeeks })
                }
              </div>
            ) : '';
          }

          return (
            <TableDatePicker
              date={rowData?.productionStartsAt}
              errorMessage={errorMessage}
              onChange={async date => {
                await ServiceProjects.updateAndAutocompleteFields(this.props.currentProject.slug, rowData.areaId.slug, 'productionStartsAt', {
                  purchaseCompleted: rowData.purchaseCompleted,
                  leadTime: rowData.leadTime,
                  productionStartsAt: date,
                })
              }}
            />
          )
        }
      },
      {
        id: 'Leveransslut_12',
        title: this.getColumnNameById('Leveransslut_12'),
        field: 'productionEndsAt',
        render: rowData => {
          return (
            <TableDatePicker
              date={rowData?.productionEndsAt}
              onChange={async date => {
                await ServiceProjects.updateProjectAreaProductionEndsAt(this.props.currentProject.slug, rowData.areaId.slug, date);
              }}
            />
          )
        }
      },
      {
        id: 'Uppskattad_ÄTA_(%)_22',
        title: this.getColumnNameById('Uppskattad_ÄTA_(%)_22'),
        field: 'estimatedAdditionsPercent',
        render: rowData => {
          return (
            <div style={{ display: "flex", justifyContent: "space-around", alignItems: "center", gap: "12px" }}>
              <LazyTooltipContainer renderReferenceComponent={(className, ref) => <InfoIcon className={className} ref={ref} />}>
                <div style={{ maxWidth: "400px" }}>
                  {t('estimatedAdditionsPercent.tooltip', 'Uppskattade kostnader för ÄTA (ändringar, tillägg, avgående) i procent av kontraktssumman.')}{" "}
                  <AverageAdditionsPercentForCategoryTooltip slug={rowData.areaId.slug} />
                </div>
              </LazyTooltipContainer>
              <TableField
                value={rowData.estimatedAdditionsPercent}
                onBlur={async (value) => {
                  await ServiceProjects.updateProjectAreaEstimatedAdditionsPercent(this.props.currentProject.slug, rowData.areaId.slug, value);
                }}
                unit="%"
                style={{ width: "40px", minWidth: "40px" }}
                className={styles.fitContent}
              />
            </div>
          );
        }
      },
      {
        id: 'Inköpsmål_%_23',
        title: this.getColumnNameById('Inköpsmål_%_23'),
        field: 'purchaseGoalPercent',
        render: rowData => {
          return (
            <div style={{ display: "flex", justifyContent: "space-around", alignItems: "center", gap: "12px" }}>
              <TooltipContainer renderReferenceComponent={(className, ref) => <InfoIcon className={className} ref={ref} />}>
                {t('purchaseGoalPercent.tooltip', 'Mål för inköpsbesparing i procent av budget.')}
              </TooltipContainer>
              <TableField
                value={rowData.purchaseGoalPercent}
                onBlur={async (value) => {
                  await ServiceProjects.updateProjectAreaPurchaseGoalPercent(this.props.currentProject.slug, rowData.areaId.slug, value);
                }}
                unit="%"
                style={{ width: "40px", minWidth: "40px" }}
                className={styles.fitContent}
              />
            </div>
          );
        }
      },
      {
        id: 'Inköpsbudget_24',
        title: this.getColumnNameById('Inköpsbudget_24'),
        render: rowData => {
          const estimatedAdditionsPercent = parseAmount(rowData.estimatedAdditionsPercent ?? 0);
          const purchaseGoalPercent = parseAmount(rowData.purchaseGoalPercent ?? 0);
          const additionsFactor = (100 + estimatedAdditionsPercent) / 100;
          const goalFactor = (100 - purchaseGoalPercent) / 100;
          const budget = parseAmount(rowData.budget ?? 0);
          const purchaseBudget = budget / additionsFactor * goalFactor;

          return purchaseBudget ? (
            <TooltipContainer renderReferenceComponent={(className, ref) => <div className={className} ref={ref}>{t('amount', '{{amount}}', { amount: formatAmount(purchaseBudget) })}</div>}>
              {t(
                'purchaseBudget.tooltip',
                'Budget justerad för uppskattad ÄTA och inköpsmål ({{amount}} kr / {{additions}}% * {{goal}}%).',
                {
                  amount: formatAmount(budget),
                  additions: _.round(additionsFactor * 100, 2),
                  goal: _.round(goalFactor * 100, 2)
                }
              )}
            </TooltipContainer>
          ) : '';
        },
        customSort: (a, b, _, order) => {
          const calculate = (rowData) => {
            const estimatedAdditionsPercent = parseAmount(rowData.estimatedAdditionsPercent ?? 0);
            const purchaseGoalPercent = parseAmount(rowData.purchaseGoalPercent ?? 0);
            const additionsFactor = (100 + estimatedAdditionsPercent) / 100;
            const goalFactor = (100 - purchaseGoalPercent) / 100;
            const budget = parseAmount(rowData.budget ?? 0);
            const purchaseBudget = budget / additionsFactor * goalFactor;
            return purchaseBudget;
          }

          return compareAmounts(calculate(a), calculate(b), order);
        },
      },
    ].filter(x => x);
  }

  reRender() {
    if (!this.hasReRendered) {
      console.log('---reRender---')
      this.setState({});
      this.hasReRendered = true;
    }
    setTimeout(() => {
      this.hasReRendered = false;
    }, 0);
  }

  async changeCallIcon(area, supplier, call) {

    let currentProject = this.props.currentProject;
    let slug = currentProject.slug;
    let areaId = area._id;
    let supplierId = supplier && supplier._id;
    let called = call ? call.isCalled : false;
    if (supplierId) {
      await ServiceProjects.dbUpdateCalled(slug, areaId, supplierId, called);
    } else {
      console.error("Price can't be updated without supplierId.");
    }
  }

  contractUploadHandler(area) {
    const winnerFlag = area.suppliers?.some(supplier => supplier.reward == true);
    if (this.props.contractUploadEvent) {
      if (winnerFlag) {
        this.props.contractUploadEvent(this, area);
      } else {
        NotificationManager.error(
          this.props.t('notification.error.noWinner.description', 'Du måste markera leverantören som vinnare i kategorin'),
          this.props.t('notification.error.noWinner.title', 'Misslyckat'),
          3000
        );
      }
    }
  }

  onChangeMeeting = async (area, meeting, { supplierId }) => {
    const { currentProject } = this.props;
    const slug = currentProject.slug;
    const areaId = area._id;
    const _supplierId = supplierId && supplierId._id;
    autosave(async () => {
      if (_supplierId) {
        await ServiceProjects.dbUpdateMeeting(slug, areaId, _supplierId, meeting);
      } else {
        console.error("Meeting can't be updated without supplierId.");
        throw new Error("Meeting can't be updated without supplierId.");
      }
    })
  };

  onCallDetail = async (area, callDetail, { supplierId }) => {
    const { currentProject } = this.props;
    const slug = currentProject.slug;
    const areaId = area._id;
    const _supplierId = supplierId && supplierId._id;
    if (_supplierId) {
      return await ServiceProjects.dbUpdateCallDetail(
        slug,
        areaId,
        _supplierId,
        callDetail,
      );
    } else {
      console.error("Call Detail can't be updated without supplierId.");
    }
  };

  onEditCallDetail = async (area, callDetailId, callDetail) => {
    const { currentProject } = this.props;
    await ServiceProjects.dbEditCallDetail(currentProject.slug, callDetailId, callDetail);
  };

  onDeleteCallDetail = async (area, callDetailId) => {
    const { currentProject } = this.props;
    await ServiceProjects.dbDeleteCallDetail(currentProject.slug, callDetailId);
  };

  onSupplierDate = async (area, suppDate, { supplierId }) => {
    const { currentProject } = this.props;
    const slug = currentProject.slug;
    const areaId = area._id;
    const _supplierId = supplierId?._id;
    if (_supplierId) {
      await ServiceProjects.dbUpdateSupplierDate(
        slug,
        areaId,
        _supplierId,
        suppDate
      );
      ServiceProjects.changeSupplierDate(
        slug,
        area.slug,
        _supplierId,
        suppDate.date
      );
    } else {
      console.error("Supplier date. [!_supplierId]");
    }
  };

  elBtnAttachClickCallback = areaId => {
    const { currentProject } = this.props;
    const history = this.props.history;
    const projectSlug = currentProject.slug;
    const area = currentProject.area.find(a => a?.areaId?._id == areaId);
    const orgSlug = appState.getCurrentOrgSlug();
    history.push(`/${orgSlug}/projects/${projectSlug}/${area?.areaId?.slug}/manual-contract`);
  };

  elInputFileChangeCallback = async (e, areaId) => {
    const { currentProject, t } = this.props;
    var files = e.target.files;
    let isValid = ServiceCheckExtension.checkFileExtension(files[0]);
    if (isValid) {
      var fileObj = files[0];
      let slug = this.props.currentProject.slug;
      try {
        const uploadedFile = await ManualContractService.uploadContract(
          fileObj,
          slug,
          areaId,
        );
        if (uploadedFile) {
          NotificationManager.success(
            t('notification.success.fileUpload.description', 'Filen har laddats upp'),
            t('notification.success.fileUpload.title', 'Sparat')
          );
          //Move bid card to avtal step on manual contract upload
          ServiceProjects.addManualContract(currentProject._id, areaId, uploadedFile);
          this.changeStepEventHandler({ _id: areaId }, false, 4);
        }
      } catch (e) {
        console.log({ e });
        this.throwErr(files[0].name);
      }
    } else {
      console.log({ e });
      this.throwErr(files[0].name);
    }
  };

  throwErr = fileName => {
    NotificationManager.error(
      this.props.t('notification.error.fileUpload.description', 'Det gick inte att ladda upp {{fileName}}', { fileName }),
      this.props.t('notification.error.fileUpload.title', 'Fel')
    );
  };

  uploadItemRemoveClickCallback = async (areaId, manualContractFilePath) => {
    const { currentProject } = this.props;
    const area = currentProject.area.find(a => a?.areaId?._id == areaId);
    if (area.manualContract?.length) {
      let slug = currentProject.slug;
      await ManualContractService.deleteContract(slug, areaId, manualContractFilePath);

      //Move bid card if no signed or manual contract exists!!!
      ServiceProjects.deleteManualContract(currentProject._id, areaId, manualContractFilePath);
      if (!area?.contracts?.find(contract => contract?.lastStatus === "closed") && area.manualContract.length === 1 && this.props.step == 4) {
        this.changeStepEventHandler(area.areaId, false, 3);
      }
    }
  };

  getCurrentStepName = () => {
    return this.state.wizard.find(wiz => wiz.step == this.props.step).name.toLowerCase();
  }

  renderOverviewItems() {
    const { t } = this.props;
    if (!this.props.currentProject) return null;

    let projectAreas = [...this.props.currentProject.area];

    const { filtersData } = this.state;
    if (filtersData.users?.length) {
      projectAreas = projectAreas.filter(area =>
        area.areaId.members?.some(m => filtersData.users.includes(m._id || m))
      );
    }

    if (projectAreas.length) {
      const currentStepName = this.getCurrentStepName();
      const areasWithVersionData = projectAreas.map(area => ({ ...area, versionData: this.state.purchaseVersionData.find(x => x.areaId === area.areaId._id)?.versionData ?? [] }));
      const searchFilteredAreas = areasWithVersionData.filter(area => area.areaId.name.toUpperCase().includes(this.props.searchValue.toUpperCase()));
      if (!searchFilteredAreas.length) {
        return (
          <div className="empty-filtered-project">
            <div>
              <h2>{t('emptyMessage.title', 'Inga upphandlingar')}</h2>
              <p>{t('emptyMessage.noResult', 'Inga kategorier i {{currentStepName}} matchar din sökning.', { currentStepName })}</p>
            </div>
          </div>
        )
      }

      const stepFilteredAreas = searchFilteredAreas.filter(area =>
        this.props.step == 6 ? true : area.step == this.props.step
      );
      if (!stepFilteredAreas.length) {
        return (
          <div className="empty-filtered-project">
            <div>
              <h2>{t('emptyMessage.title', 'Inga upphandlingar')}</h2>
              <p>{t('emptyMessage.emptyStep', 'Detta projekt har inga upphandlingar i {{currentStepName}}.', { currentStepName })}</p>
            </div>
          </div>
        )
      }

      const visibleColumns = this.state.columns.filter(x => {
        if (this.props.step === 6) {
          return x.static ? true : x.show;
        } else {
          return !x.isRenderedInStep || x.isRenderedInStep(this.props.step);
        }
      }).sort((a, b) => {
        if (this.props.step === 6) return 0;
        if (a.defaultOrder > b.defaultOrder) return 1;
        if (a.defaultOrder < b.defaultOrder) return -1;
        return 0;
      }).map(x => ({ id: x.id, name: x.name }));

      const tableColumns = visibleColumns.map(column => {
        const col = this.columns.find(c => c.id === column.id);
        return {
          ...col,
          title: React.isValidElement(col.title) ? col.title : this.getColumnNameById(col.id)
        };
      });

      // Bulk selection lives on Inköpsplan (step 6) only — it is the one tab that lists every
      // purchase in the project regardless of phase.
      const showBulkSelect = this.props.step === 6 && appState.isWriteAccessRole();
      const visibleAreaIds = stepFilteredAreas.map(a => a.areaId._id);
      const { selectedAreaIds } = this.state;

      // The checkbox rides inside the first column rather than in one of its own: that column is
      // the sticky one (`:first-child` in DataTable.module.scss), so keeping the category name
      // pinned while scrolling sideways means not displacing it.
      if (showBulkSelect && tableColumns.length) {
        const firstColumn = tableColumns[0];
        const renderCell = firstColumn.render ?? (rowData => <span>{_.get(rowData, firstColumn.field)}</span>);

        tableColumns[0] = {
          ...firstColumn,
          title: (
            <span className={styles.bulkHeaderCell}>
              <span onClick={e => e.stopPropagation()} style={{ display: 'flex' }}>
                <StyledCheckbox
                  checked={selectedAreaIds.size > 0}
                  dash={selectedAreaIds.size > 0 && selectedAreaIds.size < visibleAreaIds.length}
                  onChange={() => this.toggleBulkSelectAll(visibleAreaIds)}
                  style={{ padding: 8, margin: -8 }}
                  inputProps={{
                    'aria-label': t('bulkActions.selectAll', 'Markera alla upphandlingar'),
                    ...(selectedAreaIds.size > 0 && selectedAreaIds.size < visibleAreaIds.length
                      ? { 'aria-checked': 'mixed' }
                      : {}),
                  }}
                />
              </span>
              {firstColumn.title}
            </span>
          ),
          render: rowData => (
            <span className={styles.bulkBodyCell}>
              {/* The row click navigates into the purchase, so the checkbox swallows its own click. */}
              <span onClick={e => e.stopPropagation()} style={{ display: 'flex' }}>
                <StyledCheckbox
                  checked={selectedAreaIds.has(rowData.areaId._id)}
                  onChange={() => this.toggleBulkSelect(rowData.areaId._id)}
                  style={{ padding: 8, margin: -8 }}
                  inputProps={{ 'aria-label': t('bulkActions.selectPurchase', 'Markera {{name}}', { name: rowData.areaId.name }) }}
                />
              </span>
              {renderCell(rowData)}
            </span>
          ),
        };
      }

      if (this.props.selectedArea) {
        return areasWithVersionData.filter(val => val.areaId.slug == this.props.selectedArea).map(val => {
          let area = val.areaId;
          if (!val.step) {
            val.step = 1;
          }
          if (!val.attachment) {
            val.attachment = [];
          }

          const removeArea = async () => {
            const id = area._id;
            const name = area.name;
            const message = t('remove.button', 'Är du säker på att du vill radera {{name}}?', { name });
            if (window.confirm(message)) {
              await ServiceProjects.removeProjectArea(this.props.currentProject.slug, id);
              this.props.refreshCurrentProject();
              this.props.history.push(this.props.location.pathname.split('/').slice(0, 4).join('/'));
            }
          }

          return (
            <div
              className={`item`}
              key={area._id}
            >
              <div className="tab-container">
                <Tabs
                  tabs={[t('tabs.overview', 'Översikt')]}
                  selected={0}
                  onChange={() => { }}
                />
                <div className="tab-actions">
                  <div style={{ display: 'flex', gap: '16px', justifyContent: 'center' }}>
                    {val.publishedAt ? (
                      <BtButton leftIcon={<FlyerTakenLightIcon />} color="white" onClick={this.showUnpublishModal.bind(this)}>{t('unpublish.title', 'Avpublicera förfrågan')}</BtButton>
                    ) : (
                      <BtButton leftIcon={<FlyerTakenLightIcon />} color="white" onClick={this.showPublishModal.bind(this)}>{t('publish.title', 'Publicera förfrågan')}</BtButton>
                    )}
                    <BtButton
                      color="white"
                      leftIcon={<TrashIcon color="var(--gray-700)" size="16" />}
                      onClick={removeArea}
                    >
                      {t('remove.button', 'Ta bort')}
                    </BtButton>
                  </div>
                </div>
              </div>
              <AppProjectSinglePurchase
                attachments={val.attachment}
                key={area._id}
                step={val.step}
                areaStep={val.step}
                areaId={area._id}
                dateEnd={val.endDate}
                quotations={val.quotations}
                label={area.name}
                areaSlug={area.slug}
                suppliers={val.suppliers}
                budget={val.budget}
                estimatedContractSum={val.estimatedContractSum}
                currentProject={this.props.currentProject}
                setCurrentProject={this.props.setCurrentProject}
                allowEditing={this.props.allowEditing}
                isWinnerEditable={this.props.isWinnerEditable}
                winnerChangeEvent={this.winnerChangeEventHandler.bind(this, area)}
                changeStepEvent={(step, skipStepChange) => this.changeStepEventHandler(area, skipStepChange, step)}
                dateChangeEvent={this.dateChangeEventHandler.bind(this, area)}
                onChangeMeeting={this.onChangeMeeting.bind(this, area)}
                onCallDetail={this.onCallDetail.bind(this, area)}
                onEditCallDetail={this.onEditCallDetail.bind(this, area)}
                onDeleteCallDetail={this.onDeleteCallDetail.bind(this, area)}
                onSupplierDate={this.onSupplierDate.bind(this, area)}
                changeCallIcon={this.changeCallIcon.bind(this, area)}
                changeAreaBudget={this.changeAreaBudget.bind(this, area)}
                changeAreaEstimatedContractSum={this.changeAreaEstimatedContractSum.bind(this, area)}
                reRender={this.reRender.bind(this)}
                refreshCurrentProject={this.props.refreshCurrentProject}
                users={this.props.users}
                addSupplier={this.props.addSupplier}
                createNewVersion={this.props.createNewVersion}
                createContract={this.contractUploadHandler.bind(this, val)}
                uploadContract={this.elBtnAttachClickCallback.bind(this, area._id)}
                deleteContract={this.uploadItemRemoveClickCallback.bind(this, area._id)}
                manualContract={val.manualContract && [...val.manualContract]}
                wizard={this.state.wizard}
              />
            </div>
          );
        });
      } else {
        return (
          <>
            <DataTable
              isScrollable
              isLoading={this.state.isInitialLoading}
              columns={tableColumns}
              data={stepFilteredAreas.map(a => ({ ...a, id: a?.areaId?._id }))}
              onRowClick={this.onRowClick}
              {...this.props.tableSortingProps}
            />
            {showBulkSelect && this.renderBulkActions()}
          </>
        );
      }
    } else {
      return (
        <div className="empty-project">
          <div className="empty-project-text">
            <div className="empty-project-text-header">
              <h2>{t('emptyMessage.title', 'Inga upphandlingar')}</h2>
              {this.props.onNewArea && (
                <BtButton
                  color="primary"
                  onClick={this.props.onNewArea}
                >
                  {t('newCategoryModal.heading', 'Ny upphandling')}
                </BtButton>
              )}
            </div>
            <p>{t('emptyMessage.empty', 'Skapa en upphandling så kommer den visas här.')}</p>

          </div>

        </div>
      );
    }
  }

  loadFilterPreferences() {
    return appState.state?.token?.preferences?.purchaseFilter ?? { users: [] };
  }

  setFiltersData = (filtersData) => {
    this.setState({ filtersData });
  }

  resetFilters = () => {
    this.setState({ filtersData: { users: [] }, showFilter: false });
  }

  setColumns = async columns => {
    this.columns = this.createColumns();
    this.setState({ columns });
    const currentPreferences = appState.getProjectOverviewPreferences() || {};
    appState.setProjectOverviewPreferences({ ...currentPreferences, columns });
    await ServiceUser.updatePreferences(
      appState.getUserId(),
      { columns },
      appEnum.userPrefrences.projectOverview,
    )
  }

  showPublishModal = () => {
    this.setState({ showPublishModal: true });
  }
  hidePublishModal = () => {
    this.setState({ showPublishModal: false });
  }
  onPublish = async () => {
    await ServiceProjects.updateProjectAreaIsPublished(this.props.currentProject.slug, this.props.selectedArea, true);
    this.setState({ showPublishModal: false });
  }
  showUnpublishModal = () => {
    this.setState({ showUnpublishModal: true });
  }
  hideUnpublishModal = () => {
    this.setState({ showUnpublishModal: false });
  }
  onUnpublish = async () => {
    await ServiceProjects.updateProjectAreaIsPublished(this.props.currentProject.slug, this.props.selectedArea, false);
    this.setState({ showUnpublishModal: false });
  }

  getFilterCheckboxes() {
    const { t } = this.props;
    const currentUser = appState.getLoggedInUserDetail();

    const userSubChecks = (this.state.filterUsers || [])
      .filter(user => user.value)
      .map(user => ({
        label: user.label,
        name: 'users',
        value: user.value,
      }));

    if (currentUser && !userSubChecks.find(u => u.value === currentUser.id)) {
      userSubChecks.unshift({
        label: currentUser.name,
        name: 'users',
        value: currentUser.id,
      });
    }

    return [
      {
        label: t('filter.coworkers', 'Medarbetare'),
        name: 'users',
        value: this.state.filtersData.users || [],
        subChecks: userSubChecks,
      },
    ];
  }

  render() {
    const { searchValue, setSearchValue, t } = this.props;

    return (
      <div ref={ref => (this.element = ref)} className="app-project-overview">
        {!this.props.selectedArea && (
          <SearchBarWithActions value={searchValue} onChange={(value) => setSearchValue(value)}>
            <FiltersDropdown
              onSubmitFilter={this.setFiltersData}
              onResetFilter={this.resetFilters}
              checkboxes={this.getFilterCheckboxes()}
              showFilter={this.state.showFilter}
              toggleFilter={(show) => this.setState({ showFilter: show })}
              filtersData={this.state.filtersData}
              preferenceName={appEnum.userPrefrences.purchaseFilter}
              multiple
            />
            {this.props.step === 6 && (
              <CustomizationMenu columns={this.state.columns} setColumns={this.setColumns} />
            )}
          </SearchBarWithActions>
        )}
        <div style={{ marginTop: "16px" }}>
          {this.renderOverviewItems()}
        </div>
        <Modal
          title="Avpublicera förfrågan"
          show={this.state.showUnpublishModal}
          setShow={this.hideUnpublishModal.bind(this)}
          buttonInfo={{ label: t('unpublish.button', 'Avpublicera'), action: this.onUnpublish.bind(this) }}
        >
          <div style={{ fontSize: "14px", color: "var(--gray-700)", maxWidth: "500px" }}>
            <Trans t={t} i18nKey="unpublish.intro" />
          </div>
        </Modal>
        <Modal
          title={t('publish.title', 'Publicera förfrågan')}
          show={this.state.showPublishModal}
          setShow={this.hidePublishModal.bind(this)}
          buttonInfo={{ label: t('publish.button', 'Publicera'), action: this.onPublish.bind(this) }}
        >
          <div style={{ fontSize: "14px", color: "var(--gray-700)", maxWidth: "500px" }}>
            <Trans t={t} i18nKey="publish.intro" />
          </div>
        </Modal>
      </div>
    );
  }
}

// Wrapper component to use the hook
const AppProjectPurchaseListWithSorting = (props) => {
  const { getSortingProps } = useTableSorting(
    'projectPurchaseList',
    appEnum.userPrefrences.projectOverview
  );

  return <AppProjectPurchaseList {...props} tableSortingProps={getSortingProps()} />;
};

export default withRouter(withTranslation('projects', { keyPrefix: 'purchaseList' })(AppProjectPurchaseListWithSorting));
